import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
  useMemo,
} from "react";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  apiGroupDetailCondition,
  apiGroupMachinesDetail,
  apiGroupMachineManufacturers,
  apiGroupMachineTypes,
  apiGetMachinesDetails,
  getMachineManufacturers,
  getMachineTypes,
  apiGetMachinesTemplatePathUrl,
  apiPostMachineBulkInGroup,
  getUserPermissions,
  apiDeleteMachineInGroupBulk,
  apiMachinesTransferGroups,
  apiTransferMachinesInGroupBulk,
  apiGetMachineManufTypes,
  apiGenerateBulkQRPdf,
  getUser,
  apiGetMachineLocations,
} from "@app/api";
import {
  IconCheck,
  IconWarning,
  IconError,
  IconInvalidUrl,
  IconDeleteRow,
  IconInputError,
  IconPlus,
  IconDelete,
  IconWarningFormEdit,
  IconDeleteGray,
} from "@app/components/icons";

import {
  Avatar,
  Button,
  Box,
  Menu,
  MenuItem,
  TextField,
  FormControl,
  DialogContent,
  Divider,
  useTheme,
  useMediaQuery,
  Tooltip,
  InputLabel,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  DataTable,
  DataPagination,
  DataDialog,
  Loading,
} from "@app/components/atoms";
import {
  Announcements,
  GroupMachineLocationsRequest,
  GroupMachinesRequestDef,
} from "@app/types";
import {
  CURRENT_PAGE,
  LIMIT_PAGE,
  TOTAL_PAGE,
  TYPE_FILE_UPLOAD,
  UploadFileType,
} from "@app/constants";
import {
  formatNumberWithCommas,
  handleUploadStore,
  isMobile,
  REGEX,
  scrollToTop,
} from "@app/helpers";
import { useSelector } from "react-redux";
import { RootState, setShowAlert, store } from "@app/store";
import {
  UploadOutlined,
  DownloadOutlined,
  MoreVert,
  Visibility,
  Add,
  ViewList,
  CampaignOutlined,
  StickyNote2Outlined,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import { Cell, Workbook } from "exceljs";
import { MediaUploadMachine } from "../Components/InspectionForm/MediaUpload/MediaUploadMachine";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import MachineCard from "./MachineCard";
import { Check, Plus, Search, X } from "lucide-react";
import { Checkbox } from "@mui/material";
import heic2any from "heic2any";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { InputText } from "primereact/inputtext";
import "@app/pages/Features/GroupList/GroupDetail/MachineTab/MachineTab.css";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { apiGetAnnouncementsPopups } from "@app/api/announcements/announcements.api";
import { AnnouncementPopupModal } from "@app/components/organisms";
import MapView from "@app/components/atoms/MapView/MapView";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { format } from "date-fns";

enum MACHINE_CONDITION {
  ALL = "ALL",
  NORMAL = "NORMAL",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

type MachineType = {
  machineCount: number;
  normalStatusCount: number;
  warningStatusCount: number;
  errorStatusCount: number;
};

type MachineFilterType = {
  label: React.ReactNode;
  key: keyof MachineType;
  machineCondition: MACHINE_CONDITION | "";
  count: number;
};

type machineType = {
  id: number;
  pictureUrl?: string;
  machineName?: string;
  machineCondition?: string;
  machineManufacturerName?: string;
  machineType?: string;
  modelAndType?: string;
  serialNumber?: string;
  serviceMeter?: number;
  reportCount?: number;
  serialNumberPlatePictureUrl?: string;
  memo?: string;
  actions?: number;
};

const dataMachineFilter: MachineFilterType[] = [
  {
    label: "all",
    key: "machineCount",
    machineCondition: MACHINE_CONDITION.ALL,
    count: 0,
  },
  {
    label: <IconCheck />,
    key: "normalStatusCount",
    machineCondition: MACHINE_CONDITION.NORMAL,
    count: 0,
  },
  {
    label: <IconWarning />,
    machineCondition: MACHINE_CONDITION.WARNING,
    key: "warningStatusCount",
    count: 0,
  },
  {
    label: <IconError />,
    machineCondition: MACHINE_CONDITION.ERROR,
    key: "errorStatusCount",
    count: 0,
  },
];

export function MachineTab() {
  const [dataMachineTabList, setDataMachineTabList] =
    useState(dataMachineFilter);
  const { id } = useParams();
  const { t } = useTranslation();
  const [machineCondition, setMachineCondition] = useState<
    MACHINE_CONDITION | ""
  >(MACHINE_CONDITION.ALL);
  const [dataCell, setDataCell] = useState<machineType>();
  const [rows, setRow] = useState<machineType[]>();
  const [field, setField] = useState<string>("machineName");
  const [order, setOrder] = useState<string | undefined>();
  const [pageInfo, setPageInfo] = useState({
    total: TOTAL_PAGE,
    page: CURRENT_PAGE,
    limit: LIMIT_PAGE,
  });
  const [open, setOpen] = useState(false);
  const [isInit, setIsInit] = useState(true);
  const [openMachineDetails, setOpenMachineDetails] = useState(false);
  const [openMachineDetailsNew, setOpenMachineDetailsNew] = useState(false);
  const [openFailedMachinesTransfer, setOpenFailedMachinesTransfer] =
    useState(false);
  const [openAddMachineDetailsNew, setOpenAddMachineDetailsNew] =
    useState(false);
  const [
    openAddAvailableMachineDetailsNew,
    setOpenAddAvailableMachineDetailsNew,
  ] = useState(false);
  const [
    openAddAvailableMachineDetailsNewConfirmCancel,
    setOpenAddAvailableMachineDetailsNewConfirmCancel,
  ] = useState(false);
  const [openExcelWarn, setExcelWarn] = useState(false);
  const [openMachineDetailsStatus, setOpenMachineDetailsStatus] =
    useState(false);
  const [recordId] = useState<string | null>(null);
  const [openFormDelete, setOpenFormDelete] = useState(false);
  const [openFormDeleteBulk, setOpenFormDeleteBulk] = useState(false);
  const [openFormMachineTransfer, setOpenFormMachineTransfer] = useState(false);
  const [openFormMachineTransferConfirm, setOpenFormMachineTransferConfirm] =
    useState(false);
  const [isRequestedGroupDetailCondition, setIsRequestedGroupDetailCondition] =
    useState(false);
  const { isRequestedGroupDetail } = useSelector(
    (state: RootState) => state.groupDetail,
  );
  const [manufacturer, setmanufacturer] = useState<string | null>(null);
  const [machinetypes, setmachinetypes] = useState<string | null>(null);
  const [machinetype, setmachinetype] = useState<any[]>([]);
  const [manufacturers, setManufacturers] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [, setSelectedImageSerial] = useState<string | null>(null);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [fileError, setFileError] = useState<null | string>(null);
  const [, setFileErrorSerial] = useState<null | string>(null);
  const [, setIsImageRemoved] = useState(false);
  const [, setIsImageRemovedSerial] = useState(false);
  const [pictureFiles, setPictureFiles] = useState<File[]>([]);
  const [, setSerialNumberFiles] = useState<File[]>([]);
  const [machineStatus] = useState<MACHINE_CONDITION | "">("");
  const [activeStatus, setActiveStatus] = useState<MACHINE_CONDITION | "">("");
  const [mediaFiles, setMediaFiles] = useState<File[]>([]);
  const [refreshKey] = useState(0);
  const [, setFileCount] = useState(0);
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const [machineNumberError, setMachineNumberError] = useState<string | null>(
    null,
  );
  const [modelType, setmodelType] = useState<string | null>(null);
  const [modelTypeError, setModelTypeError] = useState<string | null>(null);
  const [customerMachineNumber, setCustomerMachineNumber] = useState("");
  const [makerOther, setmakerOther] = useState<string | null>(null);
  const [makerOtherError, setMakerOtherError] = useState<string | null>(null);
  const [machineTypeOtherError, setMachineTypeOtherError] = useState<
    string | null
  >(null);
  const [machineTypeOther, setmachineTypeOther] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [serialNo, setserialNo] = useState<string | null>(null);
  const [serialNoError, setSerialNoError] = useState(false);
  const [forbiddenCharError, setForbiddenCharError] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [, setRemovedMediaUrls] = useState<string[]>([]);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isBelowMdScreen = useMediaQuery(theme.breakpoints.down("md"));
  const MACHINE_MANUFACTURER_ID_OTHERS = "0665TE1NFG6ZXQXXYYNY15V0NW";
  const MACHINE_TYPE_ID_OTHERS = "0661J7JX6ZDP4HXM46349GPFHW";
  const [announcementsLoading, setAnnouncementsLoading] =
    useState<boolean>(false);
  const [openAnnouncements, setOpenAnnouncements] = useState(false);
  const [announcements, setAnnouncements] = useState<Announcements[]>();
  const [layoutViewMode, setLayoutViewMode] = useState<"table" | "map">(
    "table",
  );
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [showLargeCountWarning, setShowLargeCountWarning] = useState(false);

  const handleUpdateClick = () => {
    if (rowsDataTable.length > 50) {
      setShowLargeCountWarning(true);
    } else {
      handleUpdatePostMachine();
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
    clearSearch();
    handleClickMachineCondition(null, MACHINE_CONDITION.ALL);
    handleFilterChange("manufacturer", "all");
    handleFilterChange("type", "all");
  };
  const handleClose = () => {
    setAnchorEl1(null);
  };

  const getGroupDetailCondition = useCallback((id: string) => {
    return apiGroupDetailCondition(id)
      .then((res) => {
        const data = res.data.data as MachineType;

        setDataMachineTabList((prevTabs) =>
          prevTabs.map((tab) => ({
            ...tab,
            count: data[tab.key as keyof MachineType],
          })),
        );
      })
      .finally(() => {
        setIsRequestedGroupDetailCondition(true);
      });
  }, []);

  useEffect(() => {
    if (isRequestedGroupDetail) {
      getGroupDetailCondition(`${id}`);
    }
  }, [isRequestedGroupDetail, getGroupDetailCondition, id]);

  const [manufacturerSearch, setManufacturerSearch] = useState("all");
  const [vehicleTypeSearch, setVehicleTypeSearch] = useState("all");

  const [searchTextClear, setSearchTextClear] = useState("");
  const [searchTextMachine, setSearchTextMachine] = useState("");
  const [userIsoLocaleCode, setUserIsoLocaleCode] = useState<string>("");
  const [userTimeFormat, setUserTimeFormat] = useState<string>("");

  const handleSearch = () => {
    setPageInfo((prev) => ({
      ...prev,
      limit: LIMIT_PAGE,
      page: 1,
    }));
    setSearchTextMachine(searchTextClear);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && searchTextClear.trim()) {
      handleSearch();
    }
  };

  const clearSearch = () => {
    setSearchTextClear("");

    setSearchTextMachine("");
    setPageInfo((prev) => ({ ...prev, page: 1 }));
  };

  const initScrollToTop = useCallback(() => {
    if (isInit) {
      scrollToTop();
      setIsInit(false);
    }
  }, [isInit]);
  const groupMachinesDetail = useCallback(
    (id: string, param: GroupMachinesRequestDef) => {
      return apiGroupMachinesDetail(id, param).then((e) => {
        const { data, meta } = e.data;

        const formatData = convertDataRow(data);
        setRow(formatData);
        setPageInfo(meta.pageInfo);

        if (!data?.length) {
          initScrollToTop();
        }
      });
    },
    [initScrollToTop],
  );

  const groupMachineLocations = useCallback(
    async (id: string, param: GroupMachineLocationsRequest) => {
      if (!id) return;

      try {
        setMachineLocations([]);
        const response = await apiGetMachineLocations(id, param);
        const { data } = response.data;

        setMachineLocations(data || []);
        setReloadMapKey((k) => !k);

        if (!data?.length) {
          initScrollToTop();
        }
      } catch (error) {
        console.error("Error refreshing machine locations:", error);
      }
    },
    [initScrollToTop],
  );

  useEffect(() => {
    if (isRequestedGroupDetailCondition) {
      setIsLoadingTable(true);

      const finalMachineCondition =
        machineCondition === "ALL" ? "" : machineCondition;
      const finalManufacturer =
        manufacturerSearch === "all" ? "" : manufacturerSearch;
      const finalVehicleType =
        vehicleTypeSearch === "all" ? "" : vehicleTypeSearch;

      const payload = {
        limit: LIMIT_PAGE,
        page: pageInfo.page,
        ...(searchTextMachine ? { searchText: searchTextMachine } : {}),
        ...(finalMachineCondition
          ? { machineCondition: finalMachineCondition }
          : {}),
        ...(finalManufacturer
          ? { machineManufacturerName: finalManufacturer }
          : {}),
        ...(finalVehicleType ? { machineType: finalVehicleType } : {}),
        ...(field && order
          ? {
              orderBys: [{ field, order }] as [
                { field: string; order: string },
              ],
            }
          : {}),
      } satisfies GroupMachinesRequestDef;

      const promises: Promise<any>[] = [groupMachinesDetail(`${id}`, payload)];

      if (layoutViewMode === "map") {
        promises.push(
          groupMachineLocations(`${id}`, {
            ...(searchTextMachine ? { searchText: searchTextMachine } : {}),
            ...(finalMachineCondition
              ? { machineCondition: finalMachineCondition }
              : {}),
            ...(finalManufacturer
              ? { machineManufacturerName: finalManufacturer }
              : {}),
            ...(finalVehicleType ? { machineType: finalVehicleType } : {}),
          }),
        );
      }

      Promise.all(promises).finally(() => {
        setIsLoadingTable(false);
      });
    }
  }, [
    id,
    isRequestedGroupDetailCondition,
    pageInfo.page,
    field,
    order,
    machineCondition,
    manufacturerSearch,
    vehicleTypeSearch,
    searchTextMachine,
    layoutViewMode,
  ]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const getUserAPI = await getUser();
        if (!getUserAPI || !getUserAPI?.data?.data) {
          throw new Error("Failed to fetch user data");
        }

        const { isoLocaleCode, timeFormat } = getUserAPI?.data?.data;

        setUserIsoLocaleCode(isoLocaleCode);
        setUserTimeFormat(timeFormat);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    getAnnouncements();
    fetchUserData();

    return () => {};
  }, []);
  useEffect(() => {
    if (id && manufacturers.length === 0) {
      fetchMachineManufacturers(id);
    }
  }, [id, manufacturers]);
  useEffect(() => {
    if (id && machinetype.length === 0) {
      fetchMachineTypes(id);
    }
  }, [id, machinetype]);

  useEffect(() => {
    setFileCount(mediaFiles.length);
  }, [mediaFiles]);
  useEffect(() => {
    setActiveStatus(machineStatus);
  }, [machineStatus, openMachineDetailsStatus]);

  const handleFilterChange = (key: "manufacturer" | "type", value: string) => {
    setPageInfo({
      ...pageInfo,
      page: CURRENT_PAGE,
    });

    if (key === "manufacturer") {
      setManufacturerSearch(value);
    } else if (key === "type") {
      setVehicleTypeSearch(value);
    }
  };

  useEffect(() => {
    if (announcements && announcements.length > 0) {
      setOpenAnnouncements(true);
    }
  }, [announcements]);

  const getAnnouncements = () => {
    setAnnouncementsLoading(true);
    const response = apiGetAnnouncementsPopups().then((db) => {
      const data = db.data.data;
      setAnnouncements(data);
    });
    setAnnouncementsLoading(false);
    return response;
  };

  const [isButtonVisiblePer, setIsButtonVisiblePer] = useState(false);
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await getUserPermissions();
        const userPermissions = response.data?.data;

        const targetGroupId = id;

        const matchingGroup = userPermissions.groups.find(
          (group: any) => group.groupId === targetGroupId,
        );

        if (matchingGroup && matchingGroup.permissions) {
          const permissions = matchingGroup.permissions;

          const hasPermission = Object.entries(permissions).some(
            ([key, value]) =>
              key === "MACHINES" && value === "READ_CREATE_UPDATE_DELETE",
          );

          setIsButtonVisiblePer(hasPermission);
        } else {
          setIsButtonVisiblePer(false);
        }
      } catch (error) {
        console.error("Failed to fetch permissions:", error);
        setIsButtonVisiblePer(false);
      }
    };

    fetchPermissions();
  }, [id]);

  const baseColumns = [
    {
      key: "id",
      title: "",
      dataIndex: "id",

      render: (_: any, record: any) => {
        return (
          <>
            {record.pictureUrl ? (
              <Avatar
                variant="square"
                src={record.pictureUrl}
                imgProps={{
                  onError: () => {
                    const newRows = rows?.map((item) => {
                      if (item.id === record.id) {
                        item.pictureUrl = undefined;
                      }
                      return item;
                    });
                    setRow(newRows);
                  },
                  sx: {
                    objectFit: "contain",
                  },
                }}
              />
            ) : (
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconInvalidUrl />
              </Box>
            )}
          </>
        );
      },
      className: "pr-8",
      tableHeadingClassName: "d-none-imp",
      width: 50,
    },
    {
      key: "machineName",
      title: "machineInfo.customerMachineNumber",
      dataIndex: "machineName",
      sorted: true,
      tableHeadingColspan: 2,
      className: "pl-0 txt-pre-wrap",
      whiteSpace: "nowrap",
      render: (value: any, record: any) => {
        return (
          <Link
            style={{ paddingLeft: 0 }}
            className="link-style"
            to={`/groups/${id}/machines/${record.machineId}/inspection-history`}
          >
            {value}
          </Link>
        );
      },
      style: {
        minWidth: isMobile() ? 50 : 50,
      },
    },
    {
      key: "memo",
      title: "machineInfo.memo",
      dataIndex: "memo",
      align: "center",
      whiteSpace: "nowrap",
      render: (value: string) => (
        <Tooltip
          title={
            <Box
              sx={{
                maxHeight: "calc(3 * 20px + 8px)",
                boxSizing: "border-box",
                maxWidth: 320,
                overflowY: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontSize: "13px",
                lineHeight: "20px",
                padding: "4px",
              }}
            >
              {value}
            </Box>
          }
          arrow
          placement="right"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "#fff",
                color: "#1b232a",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                maxWidth: "none",
              },
            },
            arrow: {
              sx: {
                color: "#fff",
                "&::before": {
                  border: "1px solid #e0e0e0",
                },
              },
            },
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              verticalAlign: "middle",
              cursor: "pointer",
            }}
          >
            <StickyNote2Outlined
              sx={{
                color: "#1b232a",
                fontSize: 24,
                display: "block",
              }}
            />
          </Box>
        </Tooltip>
      ),
      style: {
        minWidth: 60,
      },
    },
    {
      key: "machineCondition",
      title: "dialogReport.status",
      dataIndex: "machineCondition",
      align: "center",
      render: (value: MACHINE_CONDITION) => {
        let icon;
        switch (value) {
          case MACHINE_CONDITION.NORMAL:
            icon = <IconCheck />;
            break;
          case MACHINE_CONDITION.WARNING:
            icon = <IconWarning />;
            break;
          default:
            icon = <IconError />;
        }
        return (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              verticalAlign: "middle",
              "& svg": { display: "block" },
            }}
          >
            {icon}
          </Box>
        );
      },
      whiteSpace: "nowrap",
      style: {
        minWidth: 40,
      },
    },
    {
      key: "machineManufacturerName",
      title: "machineInfo.maker",
      dataIndex: "machineManufacturerName",
      sorted: true,
      whiteSpace: "nowrap",
      style: {
        minWidth: 50,
      },
      className: "txt-pre-wrap",
    },
    {
      key: "machineType",
      title: "machineInfo.machineType",
      dataIndex: "machineType",
      sorted: true,
      style: {
        minWidth: isMobile() ? 170 : 170,
      },
      className: "txt-pre-wrap",
    },
    {
      key: "modelAndType",
      title: "machineInfo.modelType",
      dataIndex: "modelAndType",
      sorted: true,
      style: {
        minWidth: 150,
      },
      className: "txt-pre-wrap",
    },
    {
      key: "serialNumber",
      title: "machineInfo.serialNo",
      dataIndex: "serialNumber",
      render: (value: string, record: any) => (
        <span
          onClick={() => handleCellClick(record)}
          className={
            record.serialNumberPlatePictureUrl && "has-text-link pointer"
          }
        >
          {value}
        </span>
      ),
      className: "serial-number txt-pre-wrap",
      style: {
        minWidth: isMobile() ? 150 : 150,
      },
    },
    {
      key: "serviceMeter",
      title: "tableMachineDetail.serviceMeter",
      dataIndex: "serviceMeter",
      align: "right",
      whiteSpace: "nowrap",
      style: {
        minWidth: 50,
      },
      forceRender: true,
      render: (value: number) =>
        value !== null && formatNumberWithCommas(value),
    },
    {
      key: "reportCount",
      title: "groupDetailTab.reportTab",
      dataIndex: "reportCount",
      render: (value: number, record: any) => {
        return (
          <div
            className="flex align-items-center txt-nowrap"
            style={{ gap: "8px" }}
          >
            <Link
              className="link-style"
              to={`/groups/${id}/machines/${record.machineId}/report`}
            >
              {value}
            </Link>
            {!!record.reportOpenCount && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "2px 8px",
                  borderRadius: "999px",
                  backgroundColor: "#fff",
                  border: "1px solid #e0e0e0",
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "#424242",
                  lineHeight: 1.2,
                }}
              >
                <CampaignOutlined sx={{ color: "#DA9309", fontSize: 16 }} />
                {record.reportOpenCount}
              </span>
            )}
          </div>
        );
      },
      style: {
        minWidth: 100,
      },
    },
  ];
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const safeRows = rows ?? [];
  const [machineLocations, setMachineLocations] = useState<
    Record<string, unknown>[]
  >([]);

  const checkboxColumn = {
    key: "checkbox",
    title: (
      <>
        <Checkbox
          checked={
            safeRows.length > 0 && selectedRowKeys.length === safeRows.length
          }
          indeterminate={
            selectedRowKeys.length > 0 &&
            selectedRowKeys.length < safeRows.length
          }
          sx={{
            "&.Mui-checked": {
              color: "#140a9a",
            },
            "&.MuiCheckbox-indeterminate": {
              color: "#140a9a",
            },
          }}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              setSelectedRowKeys(safeRows.map((row) => row.id.toString()));
            } else {
              setSelectedRowKeys([]);
            }
          }}
        />
      </>
    ),
    dataIndex: "id",
    width: 50,
    align: "center",
    render: (_: any, record: any) => (
      <Checkbox
        checked={selectedRowKeys.includes(record.id.toString())}
        sx={{
          "&.Mui-checked": {
            color: "#140a9a",
          },
        }}
        onChange={(e) => {
          const checked = e.target.checked;
          const idStr = record.id.toString();
          setSelectedRowKeys((prev) => {
            if (checked) {
              return [...prev, idStr];
            } else {
              return prev.filter((id) => id !== idStr);
            }
          });
        }}
      />
    ),
  };
  const columns = isButtonVisiblePer
    ? [checkboxColumn, ...baseColumns]
    : [...baseColumns];

  const uploadDescription = [
    `${t("textDesUploadFile.pleaseUploadAFileShowingTheMachinePoints")}`,
    `${t("textDesUploadFile.fileFormatsThatCanBeUploadedAre")}`,
  ];

  const handleClickMachineCondition = (
    _: React.MouseEvent<HTMLElement> | null,
    machineCondition: MACHINE_CONDITION | "",
  ) => {
    setPageInfo({
      ...pageInfo,
      page: CURRENT_PAGE,
    });
    setMachineCondition(machineCondition);
  };

  const handleChangePage = (page: number) => {
    setPageInfo({
      ...pageInfo,
      page,
    });
  };

  const handleCellClick = (column: any) => {
    if (!column.serialNumberPlatePictureUrl) {
      return;
    }
    setDataCell(column);
    setOpen(true);
  };

  const handleSort = (order: string | undefined, property: string) => {
    setOrder(order);
    setField(property);
  };

  const convertDataRow = (data: machineType[]) => {
    return data.map((row: any) => ({
      ...row,
      id: row?.machineId,
    }));
  };

  const [manufacturerOptions, setManufacturerOptions] = useState<string[]>([]);
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState<string[]>([]);

  const getMachineFilterOptions = async (groupId: string) => {
    try {
      const response = await apiGetMachineManufTypes(groupId);
      const machines = response.data.data.machines;

      const manufacturerSet = new Set<string>();
      const typeSet = new Set<string>();

      machines.forEach((machine: any) => {
        if (machine.manufacturerName) {
          manufacturerSet.add(machine.manufacturerName);
        }
        if (machine.typeName) {
          typeSet.add(machine.typeName);
        }
      });

      setManufacturerOptions(Array.from(manufacturerSet));
      setVehicleTypeOptions(Array.from(typeSet));
    } catch (error) {
      console.error(
        "Failed to fetch machine manufacturer/type options:",
        error,
      );
    }
  };

  useEffect(() => {
    if (id) {
      getMachineFilterOptions(id);
    }
  }, [id]);

  const fetchMachineManufacturers = async (groupId: string) => {
    try {
      const response = await apiGroupMachineManufacturers(groupId);

      setManufacturers(response.data.data || []);
    } catch (error) {
      console.error("Error fetching machine manufacturers:", error);
    }
  };

  const fetchMachineTypes = async (groupId: string) => {
    try {
      const response = await apiGroupMachineTypes(groupId);

      setmachinetype(response.data.data || []);
    } catch (error) {
      console.error("Error fetching machine types:", error);
    }
  };

  async function updateMachine(
    groupId: string,
    machineId: string,
    input: {
      machineName: string;
      machineManufacturerId: string;
      machineTypeId: string;
      modelAndType: string;
      serialNumber: string;
      customMachineManufacturerName?: string | null;
      customTypeName?: string | null;
    },
    pictureFiles: File[],
    pictureFilesSerial: File[],
    refreshMachines: () => void,
  ) {
    try {
      store.dispatch(setShowAlert(t("machineupdated")));

      refreshMachines();
      getGroupDetailCondition(id ?? "");
      setActiveStatus("");

      setSelectedImage(null);
      setSelectedImageSerial(null);
      setFileError(null);
      setFileErrorSerial(null);

      setmanufacturer(null);
      setmachinetypes(null);
      setmakerOther(null);
      setmachineTypeOther(null);
      setmodelType(null);
      setserialNo(null);
      setCustomerMachineNumber("");

      setMachineNumberError("");
      setMakerOtherError("");
      setMachineTypeOtherError("");
      setModelTypeError("");
      setSerialNoError(false);
      setForbiddenCharError(false);
      setOpenMachineDetails(false);
      setMediaFiles([]);
      setPictureFiles([]);

      setSerialNumberFiles([]);
      setIsImageRemoved(false);
      setIsImageRemovedSerial(false);
    } catch (error) {
      console.error("Error updating machine:", error);
    }
  }

  async function updateMachineStatus(
    groupId: string,
    machineId: string,
    input: {
      machineCondition: string;
    },
    refreshMachines: () => void,
    refreshConditions: (groupId: string) => void,
  ) {
    try {
      store.dispatch(setShowAlert(t("machineupdatedstatus")));
      setOpenMachineDetailsStatus(false);
      refreshMachines();
      setActiveStatus("");
      refreshConditions(groupId);
      setSelectedImage(null);
      setSelectedImageSerial(null);
      setFileError(null);
      setFileErrorSerial(null);
      setSerialNoError(false);
      setForbiddenCharError(false);
      setmanufacturer(null);
      setmachinetypes(null);
      setmakerOther(null);
      setmachineTypeOther(null);
      setmodelType(null);
      setserialNo(null);
      setCustomerMachineNumber("");
      setMachineNumberError("");

      setMakerOtherError("");
      setMachineTypeOtherError("");
      setModelTypeError("");
      setOpenMachineDetails(false);
      setMediaFiles([]);
      setPictureFiles([]);

      setSerialNumberFiles([]);
      setIsImageRemoved(false);
      setIsImageRemovedSerial(false);
    } catch (error) {
      console.error("Error updating machine status:", error);
    }
  }

  const refreshMachineList = async () => {
    if (!id) return;
    try {
      const effectiveCondition =
        machineCondition === "ALL" ? undefined : machineCondition;

      const response = await apiGroupMachinesDetail(id, {
        limit: LIMIT_PAGE,
        page: pageInfo.page,
        ...(effectiveCondition ? { machineCondition: effectiveCondition } : {}),
        ...(field && order ? { orderBys: [{ field, order }] } : {}),
      });
      const { data, meta } = response.data;
      const formattedData = convertDataRow(data);
      setRow(formattedData);
      setPageInfo(meta.pageInfo);

      if (id) {
        getMachineFilterOptions(id);
      }
    } catch (error) {
      console.error("Error refreshing machine list:", error);
    }
  };

  const handleConvertMedia = async (files: File[]) => {
    const mediaArray = [];
    for await (const file of files) {
      if (file instanceof File) {
        const uploadedMedia = await handleUploadStore(
          UploadFileType.MACHINE,
          file,
        );
        if (uploadedMedia) {
          mediaArray.push({
            fileName: uploadedMedia.name || file.name,
            filePath: uploadedMedia.filePath,
            mediaUrl: uploadedMedia.filePath,
            mimeType: uploadedMedia.type || file.type,
          });
        }
      }
    }
    return mediaArray.filter((media) => media.fileName);
  };

  const handleBulkMachinesDelete = async (
    id: string,
    selectedIds: string[],
    refreshConditions: (id: string) => void,
  ) => {
    const payload = {
      machineIds: selectedIds,
    };

    try {
      await apiDeleteMachineInGroupBulk(id, payload);
      store.dispatch(setShowAlert(t("machinedeletedstatusBulk")));
      refreshMachineList();
      refreshConditions(id);
      setSelectedRowKeys([]);
    } catch (error) {
      console.error(`Error deleting machines from group ${id}:`, error);
    } finally {
      setOpenFormDeleteBulk(false);
    }
  };

  const DeleteMachine = async (
    id: any,
    recordId: any,
    refreshConditions: (groupId: string) => void,
  ) => {
    try {
      store.dispatch(setShowAlert(t("machinedeletedstatus")));
      refreshMachineList();
      refreshConditions(id);
    } catch (error) {
      console.error(
        `Error deleting machine with id ${recordId} from group ${id}:`,
        error,
      );
    } finally {
      setOpenFormDelete(false);
    }
  };

  const handleDownlaodExcel = async () => {
    try {
      setIsLoading(true);

      if (!id) {
        console.error("Group ID is undefined.");
        return;
      }
      const GetMachinesTemplatePathUrl = await apiGetMachinesTemplatePathUrl();

      const response = await apiGetMachinesDetails(id);
      const machineData = response.data.data;
      const fileResponse = await fetch(
        GetMachinesTemplatePathUrl.data.data.machineTemplatePathUrl,
      );

      if (!fileResponse.ok) {
        store.dispatch(setShowAlert(t("FailedtofetchtheExcelfile")));
        return;
      }

      const arrayBuffer = await fileResponse.arrayBuffer();
      const workbook = new Workbook();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.getWorksheet("Machines");
      const manufacturerSheet = workbook.getWorksheet(
        "MachinesManufacturerData",
      );
      const typesSheet = workbook.getWorksheet("MachinesTypesData");

      if (!worksheet || !manufacturerSheet || !typesSheet) {
        store.dispatch(setShowAlert(t("Requiredsheetsnotfoundintheworkbook")));
        return;
      }

      const headerRow = worksheet.getRow(1);

      headerRow.values = [
        t("machineId"),
        t("machineInfo.customerMachineNumber"),
        t("machineInfo.maker"),
        t("machineInfo.machineType"),
        t("machineInfo.modelType"),
        t("machineInfo.serialNo"),
        t("machineExcel.customMachineManufacturerNameLabel"),
        t("machineExcel.customTypeNameLabel"),
      ];

      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
      });

      const machineIdCell = worksheet.getCell("A1");

      machineIdCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBFBFBF" },
      };

      machineIdCell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };

      machineIdCell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      headerRow.commit();

      typesSheet.getCell("F2").value = "";

      typesSheet.getCell("F2").value = userIsoLocaleCode;

      const startRow = 2;
      const endRow = 5000;

      const dataValidationMachineManufacturer =
        "OFFSET('MachinesManufacturerData'!$A$2,0,0,COUNTA('MachinesManufacturerData'!$A:$A)-1,1)";
      // const dataValidationMachineTypes =
      //   "=OFFSET('MachinesTypesData'!$A$2,0,0,COUNTA('MachinesTypesData'!$A:$A)-1,1)";
      // const dataValidationMachineTypes =
      //   "=OFFSET('MachinesTypesData'!$E$2,0,0,COUNTA('MachinesTypesData'!$E:$E)-1,1)";
      const dataValidationMachineTypes = "'MachinesTypesData'!$E$1:$E$13";

      const inputMessage = {
        showInputMessage: true,
        promptTitle: "List",
        prompt: "Drag the list from the above cell",
      };

      headerRow.eachCell((cell) => {
        cell.protection = { locked: true };
      });
      worksheet.getCell("I2").protection = { locked: true };
      const password = "2286";
      worksheet.protect(password, {
        selectLockedCells: false,
        selectUnlockedCells: true,
      });
      manufacturerSheet.protect(password, {});
      typesSheet.protect(password, {});

      const applyDropdownValidation = (cell: Cell, formula: string) => {
        cell.dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`=${formula}`],
          showErrorMessage: true,
          errorTitle: "Invalid Entry",
          error: "Please select a value from the dropdown list.",
          errorStyle: "stop",
          ...inputMessage,
        };
      };

      if (machineData.length === 0) {
        for (let i = 0; i < 5000; i++) {
          const row = worksheet.getRow(startRow + i);

          applyDropdownValidation(
            row.getCell(3),
            dataValidationMachineManufacturer,
          );
          applyDropdownValidation(row.getCell(4), dataValidationMachineTypes);

          row.commit();
        }
      } else {
        for (
          let index = 0;
          index < Math.min(machineData.length, endRow - startRow + 1);
          index++
        ) {
          const row = worksheet.getRow(startRow + index);
          const machine = machineData[index];

          const rowData = [
            machine.machineId || "",
            machine.customerMachineName || "",
            machine.machineManufacturerName || "",
            machine.machineTypeName || "",
            machine.modelAndType || "",
            machine.serialNumber || "",
            machine.customMachineManufacturerName || "",
            machine.customTypeName || "",
          ];

          rowData.forEach((cellValue, colIndex) => {
            const cell = row.getCell(colIndex + 1);
            cell.value = cellValue;

            if (colIndex === 2) {
              applyDropdownValidation(cell, dataValidationMachineManufacturer);
            }
            if (colIndex === 3) {
              applyDropdownValidation(cell, dataValidationMachineTypes);
            }
          });

          row.commit();
        }

        for (let i = machineData.length; i < machineData.length + 5000; i++) {
          const row = worksheet.getRow(startRow + i);

          applyDropdownValidation(
            row.getCell(3),
            dataValidationMachineManufacturer,
          );
          applyDropdownValidation(row.getCell(4), dataValidationMachineTypes);
          row.commit();
        }
      }

      const updatedBuffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([updatedBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      const date = new Date();

      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;

      const formattedTime = `(${date
        .getHours()
        .toString()
        .padStart(2, "0")}-${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}-${date.getSeconds().toString().padStart(2, "0")})`;

      a.download = `machines-export-${formattedDate}-${formattedTime}.xlsx`;

      store.dispatch(setShowAlert(t("FileDownloadedSuccessfully")));
      a.click();
    } catch (error) {
      store.dispatch(setShowAlert(t("ErrordownloadingExcelfile")));
      console.error("Error downloading Excel file:", error);
    } finally {
      setIsLoading(false);
      handleClose();
    }
  };

  const handleMachineNumberChange = (value: string) => {
    setCustomerMachineNumber(value);

    const isValid =
      REGEX.commonNameFieldRegex.test(value) && REGEX.emojiRegex.test(value);

    if (isValid) {
      setMachineNumberError(null);
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setMachineNumberError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setMachineNumberError(t("emojisarenotallowed"));
    }
  };

  const handleMakerOtherChange = (value: string) => {
    setmakerOther(value);

    const isValid =
      REGEX.commonNameFieldRegex.test(value) && REGEX.emojiRegex.test(value);

    if (isValid) {
      setMakerOtherError(null);
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setMakerOtherError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setMakerOtherError(t("emojisarenotallowed"));
    }
  };

  const handleMachineTypeOtherChange = (value: string) => {
    setmachineTypeOther(value);

    const isNonEmpty = value.trim() !== "";
    const isValid =
      isNonEmpty &&
      REGEX.commonNameFieldRegex.test(value) &&
      REGEX.emojiRegex.test(value);

    if (isValid) {
      setMachineTypeOtherError(null);
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setMachineTypeOtherError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setMachineTypeOtherError(t("emojisarenotallowed"));
    }
  };

  const handleModelTypeChange = (value: string) => {
    setmodelType(value);

    const isNonEmpty = value.trim() !== "";
    const isValid =
      isNonEmpty &&
      REGEX.commonNameFieldRegex.test(value) &&
      REGEX.emojiRegex.test(value);

    if (isValid) {
      setModelTypeError(null);
    } else if (!isNonEmpty) {
      setModelTypeError(t("requiredNew"));
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setModelTypeError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setModelTypeError(t("emojisarenotallowed"));
    }
  };

  const [rowsDataTable, setRowsDataTable] = useState<
    {
      id: number;
      [key: string]: any;
      status?: "posted" | "updated" | "error";
    }[]
  >([]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });

  const getDataGridDisplayedRowsLabel = useCallback(
    ({ from, to, count }: { from: number; to: number; count: number }) => {
      const total = count === -1 ? to : count;
      const recordLabel =
        total === 1 ? t("record.count_one") : t("record.count_other");

      if (theme.direction === "rtl") {
        return `${recordLabel} ${total} / ${to} ~ ${from}`;
      }

      return `${from} ~ ${to} / ${total} ${recordLabel}`;
    },
    [t, theme.direction],
  );

  const dataGridPaginationSlotProps = useMemo(
    () => ({
      labelRowsPerPage: t("rowsPerPage"),
      labelDisplayedRows: getDataGridDisplayedRowsLabel,
    }),
    [t, getDataGridDisplayedRowsLabel],
  );

  const columnsDataTable: GridColDef[] = [
    {
      field: "id",
      headerName: t("id"),
      width: 50,
      hideable: false,
    },
    {
      field: "machineId",
      headerName: t("machineId"),
      width: 150,
      hideable: false,
    },
    {
      field: "machineName",
      headerName: t("machineName"),
      width: 150,
      hideable: false,
    },
    {
      field: "machineManufacturerName",
      headerName: t("machineManufacturerName"),
      width: 150,
      hideable: false,
    },
    {
      field: "machineTypeName",
      headerName: t("machineTypeName"),
      width: 150,
      hideable: false,
    },
    {
      field: "modelAndType",
      headerName: t("machineInfo.modelType"),
      width: 150,
      hideable: false,
    },
    {
      field: "serialNumber",
      headerName: t("machineInfo.serialNo"),
      width: 150,
      hideable: false,
    },
    {
      field: "customMachineManufacturerName",
      headerName: t("customMachineManufacturerName"),
      width: 150,
      hideable: false,
    },
    {
      field: "customTypeName",
      headerName: t("customTypeName"),
      width: 150,
      hideable: false,
    },
    // {
    //   field: "machineManufacturerId",
    //   headerName: t("machineManufacturerId"),
    //   width: 150,
    //   hideable: false,
    // },
    // {
    //   field: "machineTypeId",
    //   headerName: t("machineTypeId"),
    //   width: 150,
    //   hideable: false,
    // },
  ];

  const errorColumns: GridColDef[] = [
    {
      field: "id",
      headerName: t("row"),
      valueGetter: (_, row) => {
        return row.id + 1;
      },
      width: 60,
      hideable: false,
    },
    {
      field: "error",
      headerName: t("errNetwork.title"),
      width: 420,
      hideable: false,
    },
  ];

  const handleInputClick = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    handleClose();
  };

  const handleFileExcelRead = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setExcelWarn(false);
    const file = e.target.files?.[0];

    if (!file) {
      console.warn("No file selected.");
      return;
    }

    const validExtensions = [".xlsx", ".xls"];
    const fileExtension = file.name
      .slice(file.name.lastIndexOf("."))
      .toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      store.dispatch(
        setShowAlert(t("InvalidfiletypePleaseuploadanExcelfilexlsxorxls")),
      );
      return;
    }

    setIsLoading(true);

    try {
      const [manufacturerResponse, typeResponse] = await Promise.all([
        getMachineManufacturers(),
        getMachineTypes(),
      ]);

      const manufacturers = manufacturerResponse.data?.data?.data || [];
      const machineTypes = typeResponse.data?.data?.data || [];

      const reader = new FileReader();

      reader.onload = (evt) => {
        try {
          if (!evt.target) return;

          const bstr = evt.target.result as string;
          const wb = XLSX.read(bstr, { type: "binary" });

          const wsname = wb.SheetNames.find(
            (name) => name.toLowerCase() === "machines",
          );

          if (!wsname) {
            store.dispatch(setShowAlert(t("SheetnamedMachinesnotfound")));
            setIsLoading(false);
            return;
          }

          const ws = wb.Sheets[wsname];

          const rows = XLSX.utils.sheet_to_json<any[]>(ws, {
            header: 1,
            defval: "",
          });

          if (!rows || rows.length <= 1) {
            store.dispatch(
              setShowAlert(t("Thefilehasnoinformationsapartfromheaders")),
            );
            setIsLoading(false);
            return;
          }

          const COLUMN_INDEX = {
            machineId: 0,
            machineName: 1,
            machineManufacturerName: 2,
            machineTypeName: 3,
            modelAndType: 4,
            serialNumber: 5,
            customMachineManufacturerName: 6,
            customTypeName: 7,
          };

          if (rows[0].length < Object.keys(COLUMN_INDEX).length) {
            store.dispatch(setShowAlert("Invalid template format"));
            setIsLoading(false);
            return;
          }

          const dataRows = rows.slice(1);

          const getCell = (row: any[], index: number) =>
            row[index] !== undefined ? row[index] : "";

          const mappedData = dataRows
            .filter((row) =>
              row.some(
                (cell) => cell !== null && cell !== undefined && cell !== "",
              ),
            )
            .map((row, index) => ({
              id: index + 1,
              machineId: getCell(row, COLUMN_INDEX.machineId),
              machineName: getCell(row, COLUMN_INDEX.machineName),
              machineManufacturerName: getCell(
                row,
                COLUMN_INDEX.machineManufacturerName,
              ),
              machineTypeName: getCell(row, COLUMN_INDEX.machineTypeName),
              modelAndType: getCell(row, COLUMN_INDEX.modelAndType),
              serialNumber: getCell(row, COLUMN_INDEX.serialNumber),
              customMachineManufacturerName: getCell(
                row,
                COLUMN_INDEX.customMachineManufacturerName,
              ),
              customTypeName: getCell(row, COLUMN_INDEX.customTypeName),
            }));

          if (mappedData.length === 0) {
            store.dispatch(setShowAlert(t("Thefilecontainsnovaliddata")));
            setIsLoading(false);
            return;
          }

          const formattedData = mappedData.map((item, index) => {
            const manufacturer = manufacturers.find(
              (m: any) =>
                m.machineManufacturerName?.trim().toLowerCase() ===
                item.machineManufacturerName?.toString().trim().toLowerCase(),
            );

            const machineType = machineTypes.find(
              (t: any) =>
                t.machineTypeName?.trim().toLowerCase() ===
                item.machineTypeName?.toString().trim().toLowerCase(),
            );

            const rawMachineName = item.machineName
              ?.toString()
              .trim()
              .toLowerCase();

            const isInvalidMachineName =
              !rawMachineName ||
              rawMachineName === "null" ||
              rawMachineName === "undefined";

            const fallbackMachineName = `${item.modelAndType}-${item.serialNumber}`;

            return {
              ...item,
              machineName: isInvalidMachineName
                ? fallbackMachineName
                : item.machineName,
              machineManufacturerId: manufacturer
                ? manufacturer.machineManufacturerId
                : "N/A",
              machineTypeId: machineType ? machineType.machineTypeId : "N/A",
            };
          });

          setRowsDataTable(formattedData);
          setOpenMachineDetailsNew(true);
          setIsLoading(false);
        } catch (error) {
          console.error("Error processing Excel:", error);
          store.dispatch(
            setShowAlert(t("Anunexpectederroroccurredwhileprocessingthefile")),
          );
          setIsLoading(false);
        }
      };

      reader.readAsBinaryString(file);
    } catch (error) {
      console.error("Error fetching data:", error);
      store.dispatch(setShowAlert(t("Errorfetchingmachinedata")));
      setIsLoading(false);
    }
  };

  const [hasApiFailedRows, setHasApiFailedRows] = useState(false);
  const errorRows = rowsDataTable.filter((row: any) => row.status === "error");

  const validateModelType = (row: any) => {
    const isKomatsuMachine = row.machineManufacturerName === "KOMATSU";
    let processedValue: string = row.modelAndType?.toString() ?? "";
    if (isKomatsuMachine) {
      processedValue = processedValue
        .replace(/[‐‑–—‐‑‒–—⁃‑‒–—﹘―⎯⏤ーｰ─━－ー]/g, "-")
        .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (match) =>
          String.fromCharCode(match.charCodeAt(0) - 0xfee0),
        );
    }

    processedValue = processedValue
      .replace(
        /[^a-zA-Z0-9\s-_\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF\uFF21-\uFF3A\uFF41-\uFF5A\uFF10-\uFF19\uFF0D]/g,
        "",
      )
      .replace(/^\s+/, "");

    if (isKomatsuMachine) {
      processedValue = processedValue.replace(/\s/g, "").toUpperCase();
    }

    return processedValue;
  };

  const validateSerialNumber = (row: any) => {
    let processedValue: string = row.serialNumber?.toString() ?? "";
    const isKomatsu = row.machineManufacturerName === "KOMATSU";

    // 1. Full-width → half-width for all cases
    processedValue = processedValue.replace(
      /[Ａ-Ｚａ-ｚ０-９]/g,
      (match: string) => String.fromCharCode(match.charCodeAt(0) - 0xfee0),
    );

    // 2. Komatsu: uppercase + only A‑Z0‑9 allowed
    if (isKomatsu) {
      processedValue = processedValue.toUpperCase();

      const allowedCharsKomatsu = /^[A-Z0-9]$/;
      processedValue = processedValue
        .split("")
        .filter((c) => allowedCharsKomatsu.test(c))
        .join("");
    } else {
      // Non-Komatsu: keep letters, digits, spaces, hyphens
      const allowedCharsNonKomatsu = /^[A-Za-z0-9\- ]$/;
      processedValue = processedValue
        .split("")
        .filter((c) => allowedCharsNonKomatsu.test(c))
        .join("");
    }

    // 3. Komatsu: remove spaces (no spaces allowed)
    if (isKomatsu) {
      processedValue = processedValue.replace(/\s/g, "");
    }

    return processedValue;
  };

  const handleUpdatePostMachine = async () => {
    const rowsToCreate = rowsDataTable;

    const validRows: any[] = [];
    const invalidRows: any[] = [];

    const requiredFields = [
      { key: "machineName", label: "Machine Name" },
      { key: "machineManufacturerName", label: "Machine Manufacturer Name" },
      { key: "machineTypeName", label: "Machine Type Name" },
      {
        key: "modelAndType",
        label: "Model and Type",
        validate: validateModelType,
      },
      {
        key: "serialNumber",
        label: "Serial Number",
        validate: validateSerialNumber,
      },
      { key: "serialNumber", label: "Serial Number" },
      { key: "machineManufacturerId", label: "Machine Manufacturer ID" },
      { key: "machineTypeId", label: "Machine Type ID" },
    ];

    const validateRow = (row: any) => {
      const missingFields = requiredFields
        .filter((field) => {
          const value = row[field.key];

          const strValue =
            value !== null && value !== undefined
              ? value.toString().trim()
              : "";

          return strValue === "";
        })
        .map((field) => field.label);

      return missingFields.length === 0;
    };

    for (const row of rowsToCreate) {
      const transformedRow = { ...row };

      requiredFields.forEach((field) => {
        if (
          field.validate &&
          row[field.key] !== null &&
          row[field.key] !== undefined
        ) {
          transformedRow[field.key] = field.validate(transformedRow);
        }
      });

      if (validateRow(transformedRow)) {
        validRows.push(transformedRow);
      } else {
        invalidRows.push(row);
      }
    }

    setRowsDataTable((prevRows: any[]) =>
      prevRows.map((r: any) =>
        invalidRows.find((i) => i.id === r.id)
          ? {
              ...r,
              status: "error",
              error: t("machineMissingRequiredValues"),
            }
          : r,
      ),
    );

    if (invalidRows.length > 0) {
      store.dispatch(setShowAlert(t("Somerowshaveincompletedata")));
    }

    if (validRows.length === 0) {
      return;
    }

    const updateRows = validRows.filter((r) => !!r.machineId);
    const createRows = validRows.filter((r) => !r.machineId);
    const toStr = (val: any) =>
      val === null || val === undefined ? "" : val.toString().trim();
    const payload = {
      machines: [...updateRows, ...createRows].map((row) => {
        const baseMachine = {
          machineName: toStr(row.machineName),
          machineManufacturerId: toStr(row.machineManufacturerId) || "N/A",
          machineTypeId: toStr(row.machineTypeId) || "N/A",
          modelAndType: toStr(row.modelAndType),
          serialNumber: toStr(row.serialNumber),

          customMachineManufacturerName:
            row.machineManufacturerId === MACHINE_MANUFACTURER_ID_OTHERS
              ? toStr(row.customMachineManufacturerName) || null
              : null,

          customTypeName:
            row.machineTypeId === MACHINE_TYPE_ID_OTHERS
              ? toStr(row.customTypeName) || null
              : null,
        };
        if (row.machineId) {
          return {
            ...baseMachine,
            machineId: row.machineId,
          };
        } else {
          return {
            ...baseMachine,
            pictureUrl: null,
            serialNumberPlatePictureUrl: null,
          };
        }
      }),
    };

    try {
      const response = await apiPostMachineBulkInGroup(id ?? "", payload);
      const { data: successMachines, meta } = response.data;
      const failedMachines = meta?.failedMachines || [];

      const failedRowsWithId = failedMachines
        .map((fail: any) => {
          if (fail.machineId) {
            const matchedUpdate = updateRows.find(
              (r: any) => r.machineId === fail.machineId,
            );
            if (matchedUpdate) {
              return {
                id: matchedUpdate.id,
                machineId: matchedUpdate.machineId,
                serialNumber: matchedUpdate.serialNumber,
                modelAndType: matchedUpdate.modelAndType,
                error: fail.error,
              };
            }
          }

          const matchedCreate = createRows.find(
            (r: any) =>
              toStr(r.serialNumber).toLowerCase() ===
                toStr(fail.serialNumber).toLowerCase() &&
              toStr(r.modelAndType).toLowerCase() ===
                toStr(fail.modelAndType).toLowerCase(),
          );

          if (matchedCreate) {
            return {
              id: matchedCreate.id,
              serialNumber: matchedCreate.serialNumber,
              modelAndType: matchedCreate.modelAndType,
              error: fail.error,
            };
          }

          return null;
        })
        .filter(Boolean);

      if (meta?.failedCount === 0) {
        store.dispatch(setShowAlert(t("machinepostedstatus")));
      } else {
        store.dispatch(
          setShowAlert(
            `${successMachines.length} ${t("machinepostedstatus")}, ${
              meta?.failedCount
            } ${t("machinepostedstatusfailed")}`,
          ),
        );
      }

      getGroupDetailCondition(id ?? "");
      refreshMachineList();

      const seenKeys = new Set<string>();
      const duplicateRows: any[] = [];

      for (const row of createRows) {
        const key = `${toStr(row.serialNumber).toLowerCase()}-${toStr(
          row.modelAndType,
        ).toLowerCase()}`;
        if (seenKeys.has(key)) {
          duplicateRows.push(row);
        } else {
          seenKeys.add(key);
        }
      }

      if (duplicateRows.length > 0) {
        duplicateRows.forEach((dup) => {
          if (!invalidRows.find((r) => r.id === dup.id)) {
            invalidRows.push(dup);
          }
        });

        store.dispatch(setShowAlert(t("Duplicaterowsfoundinpayload")));
      }

      setRowsDataTable((prevRows: any[]) => {
        const updatedRows = prevRows.map((r: any) => {
          const isFailed = failedRowsWithId.find(
            (f: any) =>
              (f.id && f.id === r.id) ||
              (f.machineId && f.machineId === r.machineId) ||
              (!r.machineId &&
                toStr(f.serialNumber).toLowerCase() ===
                  toStr(r.serialNumber).toLowerCase() &&
                toStr(f.modelAndType).toLowerCase() ===
                  toStr(r.modelAndType).toLowerCase()),
          );

          if (isFailed) {
            return { ...r, status: "error", error: isFailed.error };
          }

          const isSuccess = successMachines.find(
            (s: any) =>
              (s.serialNumber === r.serialNumber &&
                s.modelAndType === r.modelAndType) ||
              (s.machineId && s.machineId === r.machineId),
          );

          if (isSuccess) {
            return { ...r, status: "posted" };
          }

          return r;
        });

        const onlyFailedRows = updatedRows.filter(
          (r: any) => r.status === "error",
        );
        setHasApiFailedRows(onlyFailedRows.length > 0);

        if (onlyFailedRows.length === 0 && failedMachines.length === 0) {
          setOpenMachineDetailsNew(false);
          setHasApiFailedRows(false);
        }

        return onlyFailedRows;
      });
    } catch (error) {
      console.error("Bulk machine post failed:", error);
      store.dispatch(setShowAlert(t("Stopprocessingfurtherrows")));
    }
  };

  const [cards, setCards] = useState<
    {
      cardId: string;
      index: number;
      isOpen: boolean;
      machineName: string;
      machineManufacturerId: string;
      customMachineManufacturerName: string;
      machineTypeId: string;
      customTypeName: string;
      modelAndType: string;
      serialNumber: string;
      pictureUrl: string | null;
      pictureUrlDB: string | null;
      serialNumberPlatePictureUrlDB: string | null;
      serialNumberPlatePictureUrl: File[];
      errors: { [key: string]: boolean };
      setPictureFiles: File[];
      isCopied: boolean;
    }[]
  >([]);

  const generateCardUniqueId = (existingIds: string[]): string => {
    let newId = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    do {
      newId = Array.from({ length: 26 }, () =>
        characters.charAt(Math.floor(Math.random() * characters.length)),
      ).join("");
    } while (existingIds.includes(newId));

    return newId;
  };

  const [isFormValid, setIsFormValid] = useState(false);
  const isFormInvalid = useCallback(() => {
    return (
      cards.length === 0 ||
      cards.some(
        (card) =>
          !card.machineManufacturerId.trim() ||
          !card.machineTypeId.trim() ||
          !card.modelAndType.trim() ||
          !card.serialNumber.trim(),
      )
    );
  }, [cards]);

  useEffect(() => {
    setIsFormValid(!isFormInvalid());
  }, [isFormInvalid]);

  const addNewCard = () => {
    setCards((prevCards) => {
      const existingIds = prevCards.map((card) => String(card.cardId));
      const uniqueCardId = generateCardUniqueId(existingIds);

      const newCards = [
        ...prevCards,
        {
          cardId: uniqueCardId,
          index: prevCards.length,
          isOpen: true,
          machineName: "",
          machineManufacturerId: "",
          customMachineManufacturerName: "",
          machineTypeId: "",
          customTypeName: "",
          modelAndType: "",
          serialNumber: "",
          pictureUrl: null,
          pictureUrlDB: null,
          serialNumberPlatePictureUrlDB: null,
          serialNumberPlatePictureUrl: [],
          setPictureFiles: [],
          isCopied: false,
          errors: {
            machineNumberError: false,
            makerOtherError: false,
            machineTypeOtherError: false,
            modelTypeError: false,
            serialNoError: false,
            forbiddenCharError: false,
          },
        },
      ];

      return newCards;
    });
  };

  const isAddDisabled = cards.some((card) =>
    Object.values(card.errors || {}).some((error) => error),
  );
  const updateCardError = useCallback(
    (cardId: string, field: string, hasError: boolean) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? { ...card, errors: { ...card.errors, [field]: hasError } }
            : card,
        ),
      );
    },
    [],
  );

  const updateSerialNumberPlatePictureUrl = useCallback(
    (cardId: string, serialNumberPlatePictureUrl: File[]) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? {
                ...card,
                serialNumberPlatePictureUrl: serialNumberPlatePictureUrl,
              }
            : card,
        ),
      );
    },
    [],
  );

  const updateSetPictureFiles = useCallback(
    (cardId: string, setPictureFiles: File[]) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? { ...card, setPictureFiles: setPictureFiles }
            : card,
        ),
      );
    },
    [],
  );

  const updatePictureUrl = useCallback(
    (cardId: string, pictureUrl: string | null) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId ? { ...card, pictureUrl: pictureUrl } : card,
        ),
      );
    },
    [],
  );

  const updateMachineName = useCallback(
    (cardId: string, machineName: string) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId ? { ...card, machineName: machineName } : card,
        ),
      );
    },
    [],
  );

  const validateForm = useCallback(() => {
    setIsFormValid(!isFormInvalid());
  }, [isFormInvalid]);

  const updateMachineManufacturerId = useCallback(
    (cardId: string, machineManufacturerId: string) => {
      let hasError = false;
      setCards((prevCards) =>
        prevCards.map((card) => {
          if (card.cardId === cardId) {
            const newSerialNumber = card.serialNumber;

            if (machineManufacturerId === "0661ATBN7XH5EB1NXCFDF4ZTMG") {
              hasError =
                card.machineTypeId === "0661J7JX6ZDP4HXM46349GPFHW"
                  ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                      newSerialNumber,
                    )
                  : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                      newSerialNumber,
                    );
            } else {
              hasError = newSerialNumber.length > 20;
            }

            return {
              ...card,
              machineManufacturerId,
              errors: {
                ...card.errors,
                serialNoError: hasError,
                forbiddenCharError: false,
              },
            };
          }
          return card;
        }),
      );
      setSerialNoError(hasError);
      setForbiddenCharError(false);

      validateForm();
    },
    [validateForm],
  );

  const updateCustomMachineManufacturerName = useCallback(
    (cardId: string, customMachineManufacturerName: string) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? {
                ...card,
                customMachineManufacturerName: customMachineManufacturerName,
              }
            : card,
        ),
      );
    },
    [],
  );

  const updateMachineTypeId = useCallback(
    (cardId: string, machineTypeId: string) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? { ...card, machineTypeId: machineTypeId }
            : card,
        ),
      );
    },
    [],
  );

  const updateCustomTypeName = useCallback(
    (cardId: string, customTypeName: string) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? { ...card, customTypeName: customTypeName }
            : card,
        ),
      );
    },
    [],
  );

  const updateModelAndType = useCallback(
    (cardId: string, modelAndType: string) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? { ...card, modelAndType: modelAndType }
            : card,
        ),
      );
    },
    [],
  );

  const updateSerialNumber = useCallback(
    (cardId: string, serialNumber: string) => {
      setCards((prevCards) =>
        prevCards.map((card) =>
          card.cardId === cardId
            ? { ...card, serialNumber: serialNumber }
            : card,
        ),
      );
    },
    [],
  );

  const deleteCard = useCallback((cardId: string) => {
    setCards((prevCards) => {
      const updatedCards = prevCards.filter((card) => card.cardId !== cardId);

      return updatedCards.map((card, newIndex) => ({
        ...card,
        index: newIndex,
      }));
    });
  }, []);

  const submitMachines = async () => {
    if (!isFormValid || isAddDisabled || !id) return;

    const failedMachines: any[] = [];

    try {
      const machinePayloads = await Promise.all(
        cards.map(async (card) => {
          try {
            const serialImages =
              card.serialNumberPlatePictureUrl?.length > 0
                ? await handleConvertMedia(card.serialNumberPlatePictureUrl)
                : [];

            const pictureImages =
              card.setPictureFiles?.length > 0
                ? await handleConvertMedia(card.setPictureFiles)
                : [];

            const fallbackName = !card.machineName?.trim()
              ? `${card.modelAndType}-${card.serialNumber}`
              : card.machineName;

            return {
              cardId: card.cardId,

              machineName: fallbackName,
              machineManufacturerId: card.machineManufacturerId,
              machineTypeId: card.machineTypeId,
              modelAndType: card.modelAndType,
              serialNumber: card.serialNumber,

              pictureUrl:
                pictureImages.length > 0
                  ? pictureImages[0].mediaUrl
                  : card.pictureUrlDB || null,
              serialNumberPlatePictureUrl:
                serialImages.length > 0
                  ? serialImages[0].mediaUrl
                  : card.serialNumberPlatePictureUrlDB || null,
              customMachineManufacturerName:
                card.machineManufacturerId === "0665TE1NFG6ZXQXXYYNY15V0NW" &&
                card.customMachineManufacturerName.trim()
                  ? card.customMachineManufacturerName
                  : null,
              customTypeName:
                card.machineTypeId === "0661J7JX6ZDP4HXM46349GPFHW" &&
                card.customTypeName.trim()
                  ? card.customTypeName
                  : null,
            };
          } catch (err) {
            failedMachines.push(card);
            return null;
          }
        }),
      );

      const validMachines = machinePayloads.filter(
        (m): m is NonNullable<typeof m> => m !== null,
      );

      if (validMachines.length === 0) {
        store.dispatch(setShowAlert(t("machinepostedstatusfailederror")));
        return;
      }

      const response = await apiPostMachineBulkInGroup(id, {
        machines: validMachines,
      });

      const { meta } = response.data;

      if (meta) {
        const {
          failedMachines: failedFromAPI = [],

          successCount,
          failedCount,
        } = meta;

        if (failedCount === 0) {
          store.dispatch(setShowAlert(t("machinepostedstatus")));
        } else {
          store.dispatch(
            setShowAlert(
              `${successCount} ${t("machinepostedstatus")}, ${failedCount} ${t(
                "machinepostedstatusfailed",
              )}`,
            ),
          );
        }

        const failedCardMatches = cards.filter((card) =>
          failedFromAPI.some(
            (fail: any) =>
              fail.machineName === card.machineName &&
              fail.serialNumber === card.serialNumber &&
              fail.modelAndType === card.modelAndType,
          ),
        );

        const totalFailed = [...failedMachines, ...failedCardMatches];

        setCards(totalFailed);

        if (totalFailed.length === 0) {
          setOpenAddMachineDetailsNew(false);
        }

        refreshMachineList();
        getGroupDetailCondition(id);
      } else {
        store.dispatch(setShowAlert(t("machinepostedstatusfailed")));
        setCards(cards);
      }
    } catch (err) {
      store.dispatch(setShowAlert(t("machinepostedstatusfailederror")));
      store.dispatch(setShowAlert(t("Stopprocessingfurthecards")));
      setCards(cards);
    }
  };

  useEffect(() => {
    if (manufacturer !== "0661ATBN7XH5EB1NXCFDF4ZTMG") {
      setSerialNoError(false);
      setForbiddenCharError(false);
    }
  }, [manufacturer]);

  const [searchText, setSearchText] = useState<string>("");
  const [selectedMachines, setSelectedMachines] = useState<{
    [key: number]: boolean;
  }>({});
  const [selectedMachineList, setSelectedMachineList] = useState<any[]>([]);
  const [machines, setMachines] = useState<any[]>([]);
  const [groupsList, setGroupsList] = useState<string[]>([]);
  const [machineTypesList, setMachineTypesList] = useState<string[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<string>("all");
  const [selectedMachineType, setSelectedMachineType] = useState<string>("all");
  const [loading] = useState(false);

  const filteredMachines = machines.filter((machine) => {
    const searchLower = searchText.replace(/\s/g, "").toLowerCase();
    const machineValues = [
      machine.machineName,
      machine.customMachineManufacturerName,
      machine.customTypeName,
      machine.serialNumber,
      machine.typeName,
      machine.modelAndType,
      machine.machineManufacturerName,
    ];

    const isSearchMatch = machineValues.some((value) =>
      (value?.toString().replace(/\s/g, "").toLowerCase() || "").includes(
        searchLower,
      ),
    );

    const isGroupMatch =
      selectedGroup === "all" || machine.groupName === selectedGroup;
    const isTypeMatch =
      selectedMachineType === "all" || machine.typeName === selectedMachineType;

    return isSearchMatch && isGroupMatch && isTypeMatch;
  });

  const toggleSelection = (machine: any) => {
    setSelectedMachines((prev) => {
      const updated = {
        ...prev,
        [machine.machineId]: !prev[machine.machineId],
      };

      const allSelected = filteredMachines.every((m) => updated[m.machineId]);
      setSelectAll(allSelected);

      return updated;
    });

    setSelectedMachineList((prevList) => {
      if (prevList.some((m) => m.machineId === machine.machineId)) {
        return prevList.filter((m) => m.machineId !== machine.machineId);
      } else {
        return [...prevList, machine];
      }
    });
  };

  const [selectAll, setSelectAll] = useState(false);

  const isDisabled = selectedRowKeys.length === 0;

  const [groupOptions, setGroupOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const handleOpenMachineTransfer = async () => {
    try {
      setOpenFormMachineTransfer(true);

      const response = await apiMachinesTransferGroups(id ?? "");
      const options = [
        ...response.data.data.groups.map((group: any) => ({
          value: group.groupId,
          label: group.groupName,
        })),
      ];

      setGroupOptions(options);
    } catch (error) {
      console.error("Error fetching transfer groups:", error);
    }
  };

  const [selectedGroupMachineTransfer, setSelectedGroupMachineTransfer] =
    useState<string>("");
  const handleGroupChangeTransferMachine = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSelectedGroupMachineTransfer(event.target.value);
  };

  const [failedMachines, setFailedMachines] = useState<any[]>([]);

  const handleBulkMachinesTransfer = async (
    id: string,
    selectedIds: string[],
    refreshConditions: (id: string) => void,
  ) => {
    const selectedGroup = groupOptions.find(
      (option) => option.value === selectedGroupMachineTransfer,
    );

    const payload = {
      currentGroupId: id,
      transferGroupId: selectedGroupMachineTransfer,
      transferGroupName: selectedGroup?.label,
      machineIds: selectedIds,
    };

    try {
      const response = await apiTransferMachinesInGroupBulk(payload);

      refreshMachineList();
      refreshConditions(id);
      setSelectedRowKeys([]);
      setSelectedGroupMachineTransfer("");
      if (response.data.data.passCount > 0) {
        store.dispatch(setShowAlert(t("machinetransferstatusBulk")));
      }

      if (response.data.data.failedCount > 0) {
        setFailedMachines(response.data.data.failedMachines ?? []);
        setOpenFailedMachinesTransfer(true);
      }
    } catch (error) {
      console.error(`Error transfer machines to group ${id}:`, error);
    } finally {
      setOpenFormMachineTransfer(false);
      setOpenFormMachineTransferConfirm(false);
    }
  };

  const columnsDataTableFailedMachines = [
    { field: "id", headerName: "ID", width: 50, hideable: false },
    {
      field: "machineName",
      headerName: "Machine Name",
      width: 210,
      hideable: false,
    },
    {
      field: "modelAndType",
      headerName: "Model-Type",
      width: 210,
      hideable: false,
    },
    {
      field: "serialNumber",
      headerName: "Serial Number",
      width: 210,
      hideable: false,
    },

    {
      field: "transferGroupName",
      headerName: "Transfer Group Name",
      width: 210,
      hideable: false,
    },
  ];

  const [anchorElActions, setAnchorElActions] = useState<null | HTMLElement>(
    null,
  );
  const [noMachines, setNoMachines] = useState<boolean>(false);
  const [reloadMapKey, setReloadMapKey] = useState<boolean>(false);

  const openActions = Boolean(anchorElActions);

  const handleCloseActions = () => {
    setAnchorElActions(null);
  };

  const handleDownloadBulkQR = async (
    machines: {
      modelType: string;
      serialNumber: string;
      customerMachineNumber: string;
    }[],
  ) => {
    if (!Array.isArray(machines) || machines.length === 0) {
      console.warn("No machines provided for bulk QR PDF download.");
      return;
    }

    try {
      const now = new Date();
      const datePart = now.toLocaleDateString("en-GB").replace(/\//g, "-");
      const timePart = now
        .toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/:/g, "-");

      const formattedDateTime = `${datePart}_${timePart}`;
      const filename = `${t("qr")}_${formattedDateTime}.pdf`;

      const response = await apiGenerateBulkQRPdf(machines, filename);

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to generate bulk QR PDF:", error);
    }
  };

  const handleLayoutViewChange = (
    e: React.MouseEvent<HTMLElement>,
    newValue: "table" | "map" | null,
  ) => {
    if (newValue) {
      setLayoutViewMode(newValue);
    }
  };

  const toggleButtonSelectedStyle = {
    "&.Mui-selected": {
      backgroundColor: "#eae9ff",
      borderColor: "#253fc8",
      color: "#253fc8",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#dedeff",
    },
  };
  const MapTooltip = ({
    selectedDataIndex,
  }: {
    selectedDataIndex?: number;
  }) => {
    const machine = machineLocations?.[selectedDataIndex ?? 0];
    return (
      <div className="map-tooltip">
        <Divider style={{ marginBottom: 10 }} />
        <div className="tooltip-row">
          <p className="fs-14 default-font content-margin fw-bold tooltip-label">
            {t("machineInfo.maker")}:
          </p>
          <p
            className="fs-14 default-font content-margin ellipsis"
            title={machine?.machineManufacturerName as string}
          >
            {machine?.machineManufacturerName as string}
          </p>
        </div>

        <div className="tooltip-row">
          <p className="fs-14 default-font content-margin fw-bold tooltip-label">
            {t("machineInfo.machineType")}:
          </p>
          <p
            className="fs-14 default-font content-margin ellipsis"
            title={machine?.machineTypeName as string}
          >
            {machine?.machineTypeName as string}
          </p>
        </div>

        <div className="tooltip-row">
          <p className="fs-14 default-font content-margin fw-bold tooltip-label">
            {t("machineInfo.modelType")}:
          </p>
          <p
            className="fs-14 default-font content-margin ellipsis"
            title={machine?.modelType as string}
          >
            {machine?.modelType as string}
          </p>
        </div>

        <div className="tooltip-row">
          <p className="fs-14 default-font content-margin fw-bold tooltip-label">
            {t("machineInfo.serialNo")}:
          </p>
          <p
            className="fs-14 default-font content-margin ellipsis"
            title={machine?.serialNumber as string}
          >
            {machine?.serialNumber as string}
          </p>
        </div>

        <div className="tooltip-row">
          <p className="fs-14 default-font content-margin fw-bold tooltip-label">
            {t("tableMachineDetail.date")}:
          </p>
          <p className="fs-14 default-font content-margin ellipsis">
            {format(new Date(machine?.lastUpdatedAt as string), userTimeFormat)}
          </p>
        </div>

        <Divider component={"p"} style={{ marginBottom: 10, marginTop: 10 }} />

        <Link
          style={{ paddingLeft: 0 }}
          className="link-style fs-14 default-font"
          to={`/groups/${id}/machines/${machine?.machineId}/inspection-history`}
        >
          {t("mapView.machineDetailLink")}
        </Link>
      </div>
    );
  };
  const MapTooltipHeader = ({
    selectedDataIndex,
  }: {
    selectedDataIndex: number;
  }) => {
    const machine = machineLocations?.[selectedDataIndex ?? 0];
    return (
      <h4
        className="default-font ellipsis"
        title={machine?.customerMachineName as string}
        style={{ margin: 0, maxWidth: 250 }}
      >
        {machine?.customerMachineName as string}
      </h4>
    );
  };
  useLayoutEffect(() => {
    setNoMachines(!!(layoutViewMode === "map" && rows && rows.length === 0));
  }, [rows, layoutViewMode]);

  const renderMachineCard = useCallback(
    (card: any) => {
      return (
        <MachineCard
          key={card.cardId}
          cardId={card.cardId}
          index={card.index}
          defaultOpen={card.isOpen}
          manufacturers={manufacturers}
          machinetype={machinetype}
          machineName={card.machineName}
          onMachineNameChange={(machineName: string) =>
            updateMachineName(card.cardId, machineName)
          }
          machineManufacturerId={card.machineManufacturerId}
          onMachineManufacturerIdChange={(machineManufacturerId: string) =>
            updateMachineManufacturerId(card.cardId, machineManufacturerId)
          }
          customMachineManufacturerName={card.customMachineManufacturerName}
          oncustomMachineManufacturerNameChange={(
            customMachineManufacturerName: string,
          ) =>
            updateCustomMachineManufacturerName(
              card.cardId,
              customMachineManufacturerName,
            )
          }
          machineTypeId={card.machineTypeId}
          onmachineTypeIdChange={(machineTypeId: string) =>
            updateMachineTypeId(card.cardId, machineTypeId)
          }
          customTypeName={card.customTypeName}
          oncustomTypeNameChange={(customTypeName: string) =>
            updateCustomTypeName(card.cardId, customTypeName)
          }
          modelAndType={card.modelAndType}
          onmodelAndTypeChange={(modelAndType: string) =>
            updateModelAndType(card.cardId, modelAndType)
          }
          serialNumber={card.serialNumber}
          onserialNumberChange={(serialNumber: string) =>
            updateSerialNumber(card.cardId, serialNumber)
          }
          onDelete={deleteCard}
          pictureUrl={card.pictureUrl}
          pictureUrlChange={(pictureUrl: string | null) =>
            updatePictureUrl(card.cardId, pictureUrl)
          }
          serialNumberPlatePictureUrl={card.serialNumberPlatePictureUrl}
          onserialNumberPlatePictureUrlChange={(
            serialNumberPlatePictureUrl: File[],
          ) =>
            updateSerialNumberPlatePictureUrl(
              card.cardId,
              serialNumberPlatePictureUrl,
            )
          }
          setCardOpenClose={setCards}
          onErrorChange={updateCardError}
          setPictureFiles={(setPictureFiles: File[]) =>
            updateSetPictureFiles(card.cardId, setPictureFiles)
          }
          isCopied={card.isCopied}
        />
      );
    },
    [
      manufacturers,
      machinetype,
      updateMachineName,
      updateMachineManufacturerId,
      updateCustomMachineManufacturerName,
      updateMachineTypeId,
      updateCustomTypeName,
      updateModelAndType,
      updateSerialNumber,
      deleteCard,
      updatePictureUrl,
      updateSerialNumberPlatePictureUrl,
      setCards,
      updateCardError,
      updateSetPictureFiles,
    ],
  );

  return (
    <div className="machine-tab">
      <Box
        className="toggle-btn-group"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 3,
        }}
      >
        <Box
          className="toggle-btn-group"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            width: "100%",
            gap: 2,
            pl: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel id="machine-condition-label">
                {t("dialogReport.status")}
              </InputLabel>
              <Select
                labelId="machine-condition-label"
                value={machineCondition}
                label={t("dialogReport.status")}
                displayEmpty
                onChange={(e) => {
                  handleClickMachineCondition(
                    null,
                    e.target.value as MACHINE_CONDITION | "",
                  );
                }}
                renderValue={(selected: MACHINE_CONDITION | "") => {
                  switch (selected) {
                    case MACHINE_CONDITION.NORMAL:
                      return t("normal");
                    case MACHINE_CONDITION.WARNING:
                      return t("warning");
                    case MACHINE_CONDITION.ERROR:
                      return t("errNetwork.title");
                    case MACHINE_CONDITION.ALL:
                      return t("all");
                    default:
                      return t("all");
                  }
                }}
              >
                {dataMachineTabList.map((tab, index) => (
                  <MenuItem
                    key={index}
                    value={tab.machineCondition}
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    {typeof tab.label !== "string" && tab.label}
                    {(() => {
                      switch (tab.machineCondition) {
                        case MACHINE_CONDITION.NORMAL:
                          return t("normal");
                        case MACHINE_CONDITION.WARNING:
                          return t("warning");
                        case MACHINE_CONDITION.ERROR:
                          return t("errNetwork.title");
                        case MACHINE_CONDITION.ALL:
                          return t("all");
                        default:
                          return t("all");
                      }
                    })()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>{t("machineInfo.maker")}</InputLabel>
              <Select
                value={manufacturerSearch}
                onChange={(e) => {
                  handleFilterChange("manufacturer", e.target.value);
                }}
                label={t("machineInfo.maker")}
              >
                <MenuItem value="all">{t("all")}</MenuItem>
                {manufacturerOptions.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>{t("machineInfo.machineType")}</InputLabel>
              <Select
                value={vehicleTypeSearch}
                onChange={(e) => {
                  handleFilterChange("type", e.target.value);
                }}
                label={t("machineInfo.machineType")}
              >
                <MenuItem value="all">{t("all")}</MenuItem>
                {vehicleTypeOptions.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <div
            className="input-field"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginBottom: "15px",
              marginTop: "-10px",
              paddingRight: "0px",
              position: "relative",
            }}
          >
            <div style={{ position: "relative" }}>
              <InputText
                type="text"
                value={searchTextClear}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value;

                  setSearchTextClear(value);
                  if (value.trim() === "") {
                    setSearchTextMachine("");
                    setPageInfo((prev) => ({ ...prev, page: 1 }));
                  }
                }}
                onKeyDown={handleKeyDown}
                placeholder={t("Customermachinenumber")}
                className="custom-input"
                style={{
                  width: "277px",
                  paddingLeft: "1.0rem",
                  paddingRight: "2rem",
                  height: "50px",
                  border: "1.5px solid #bcbcbc",
                  borderRadius: "30px",
                  boxSizing: "border-box",
                }}
              />
              {searchTextClear && (
                <button
                  className="clear-button"
                  onClick={clearSearch}
                  aria-label="Clear search"
                  type="button"
                >
                  ×
                </button>
              )}
            </div>
          </div>
        </Box>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={3}
            md={2}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: { xs: "flex-start" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: 1,
              width: "100%",
              mt: 1,
              ml: { xs: 2, sm: 0 },
            }}
          >
            <Box sx={{ direction: "ltr", display: "inline-flex" }}>
              <ToggleButtonGroup
                size="small"
                exclusive
                value={layoutViewMode}
                onChange={handleLayoutViewChange}
              >
                <Tooltip title={t("listView")} arrow>
                  <ToggleButton value="table" sx={toggleButtonSelectedStyle}>
                    <ViewList fontSize="small" />
                  </ToggleButton>
                </Tooltip>

                <Tooltip title={t("mapView.title")} arrow>
                  <ToggleButton value="map" sx={toggleButtonSelectedStyle}>
                    <LocationOnIcon fontSize="small" />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={9}
            md={10}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: { xs: "flex-start", sm: "flex-end" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: 1,
              width: "100%",
              mt: 1,
              ml: { xs: 2, sm: 0 },
            }}
          >
            {isButtonVisiblePer && (
              <>
                <Button
                  className="btn btn-primary"
                  startIcon={<IconPlus />}
                  variant="contained"
                  onClick={() => {
                    setOpenAddMachineDetailsNew(true);
                  }}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                  }}
                >
                  {t("formAction.Addmachine")}
                </Button>

                <Button
                  className="btn btn-no-border-dark-blue"
                  startIcon={<MoreVert />}
                  onClick={handleClick}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                  }}
                >
                  {t("formAction.options")}
                </Button>

                <Button
                  disabled={isDisabled}
                  className="btn btn-no-border-dark-blue"
                  startIcon={<CompareArrowsIcon fontSize="small" />}
                  onClick={() => {
                    handleOpenMachineTransfer();
                  }}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                  }}
                >
                  {t("formAction.transfer")}
                </Button>
                <Button
                  disabled={isDisabled}
                  className="btn btn-no-border-dark-blue"
                  startIcon={<QrCode2Icon fontSize="small" />}
                  onClick={() => {
                    const selectedMachines = rows
                      ?.filter(
                        (row) =>
                          selectedRowKeys.includes(row.id.toString()) &&
                          typeof row.modelAndType === "string" &&
                          typeof row.serialNumber === "string" &&
                          typeof row.machineName === "string",
                      )
                      .map((row) => ({
                        modelType: row.modelAndType as string,
                        serialNumber: row.serialNumber as string,
                        customerMachineNumber: row.machineName as string,
                      }));

                    handleDownloadBulkQR(selectedMachines ?? []);

                    setSelectedRowKeys([]);
                  }}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                  }}
                >
                  {t("formAction.2DCode")}
                </Button>

                <Button
                  className="btn btn-no-border-error"
                  disabled={isDisabled}
                  startIcon={
                    isDisabled ? (
                      <IconDeleteGray light />
                    ) : (
                      <IconDelete size={15} />
                    )
                  }
                  onClick={() => {
                    setOpenFormDeleteBulk(true);
                  }}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  {t("formAction.delete")}
                </Button>
              </>
            )}

            <Menu
              anchorEl={anchorElActions}
              open={openActions}
              onClose={handleCloseActions}
            ></Menu>

            <div>
              <Menu
                anchorEl={anchorEl1}
                open={Boolean(anchorEl1)}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={() => {
                    handleDownlaodExcel();
                    handleClose();
                  }}
                >
                  <DownloadOutlined style={{ marginRight: "10px" }} />

                  {t("formAction.downloadexcel")}
                </MenuItem>

                <MenuItem>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      width: "100%",
                    }}
                  >
                    <UploadOutlined style={{ marginRight: "10px" }} />
                    {t("formAction.uploadexcel")}
                    <input
                      style={{ display: "none" }}
                      onClick={() => {
                        setAnchorEl1(null);
                        setTimeout(() => setExcelWarn(true), 100);
                      }}
                    />
                  </label>
                </MenuItem>
              </Menu>

              {isLoading && <Loading />}
            </div>
          </Grid>
        </Grid>
      </Box>

      {layoutViewMode === "table" && (
        <div className="machine-table">
          <DataTable
            columns={columns}
            dataSource={rows}
            textEmptyData="noGroupDetailMachines"
            onRequestSort={handleSort}
            onCellClick={handleCellClick}
            didScrollTop={() => {
              initScrollToTop();
            }}
            loading={isLoadingTable}
          />

          <DataPagination
            isHidden={!rows?.length}
            className="mt-25 sp-p24"
            currentPage={pageInfo.page}
            limitPage={pageInfo.limit}
            totalPage={pageInfo.total}
            handleChangePage={handleChangePage}
          />
        </div>
      )}

      {layoutViewMode === "map" && (
        <Grid container spacing={noMachines ? 0 : 2}>
          <Grid item xs={12} sm={12} md={5} lg={4} xl={3}>
            <div className="machine-table">
              <DataTable
                columns={columns.slice(0, 3)}
                dataSource={rows}
                textEmptyData="noGroupDetailMachines"
                onRequestSort={handleSort}
                onCellClick={handleCellClick}
                didScrollTop={() => {
                  initScrollToTop();
                }}
                tableMinHeight={isBelowMdScreen ? undefined : 450}
                tableMinWidth={340}
                hideTableEmpty={noMachines}
                loading={isLoadingTable}
              />
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={noMachines ? 12 : 7}
            lg={noMachines ? 12 : 8}
            xl={noMachines ? 12 : 9}
            className="map"
            sx={{
              marginTop: noMachines ? 0 : "1.75rem",
              height: { xs: "466px" },
            }}
          >
            <MapView
              locations={machineLocations.map((value) => ({
                key: value.machineId as string,
                location: {
                  lat: Number(value.lat),
                  lng: Number(value.lng),
                },
                iconUrl: value.pictureUrl as string,
                checked: selectedRowKeys.includes(value.machineId as string),
              }))}
              ToolTipComponent={MapTooltip}
              ToolTipHeader={MapTooltipHeader}
              mapReloadkey={reloadMapKey.toString()}
              machinesExist={!!(rows && rows.length > 0)}
            />
            <p>* {t("mapNote")}</p>
          </Grid>
          <Grid item xs={12} md={12}>
            <DataPagination
              isHidden={!rows?.length}
              className="mt-25 sp-p24"
              currentPage={pageInfo.page}
              limitPage={pageInfo.limit}
              totalPage={pageInfo.total}
              handleChangePage={handleChangePage}
            />
          </Grid>
        </Grid>
      )}

      {dataCell && (
        <DataDialog
          disableBackdropClick={true}
          title={t("serialNumberPlate")}
          open={open}
          dialogActions={
            <Button
              onClick={() => setOpen(false)}
              className="btn btn-no-border"
            >
              {t("dialogRefuel.close")}
            </Button>
          }
        >
          {dataCell.serialNumberPlatePictureUrl ? (
            <img
              className="img-dialog"
              src={`${dataCell.serialNumberPlatePictureUrl}`}
              alt={dataCell.machineManufacturerName}
              loading="lazy"
              onError={() => {
                setDataCell({
                  ...dataCell,
                  serialNumberPlatePictureUrl: undefined,
                });
              }}
            />
          ) : (
            <Box
              sx={{
                width: 512,
                height: 512,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconInvalidUrl />
            </Box>
          )}
        </DataDialog>
      )}

      <DataDialog
        disableBackdropClick={true}
        open={openFailedMachinesTransfer}
        setOpen={setOpenFailedMachinesTransfer}
        title={t("machinesFailedTransfer")}
        className="dialog-inspection-form"
      >
        <div
          className="warning flex justify-content-start"
          style={{ marginTop: 0, marginBottom: "10px" }}
        >
          <IconWarningFormEdit />
          <span style={{ marginLeft: 12, flex: 1 }} className="txt-black-1">
            {t("warningFailedTransferMachines")}
          </span>
        </div>

        <div
          style={{
            width: "100%",
            height: 400,
            overflow: "auto",
            marginBottom: "20px",
          }}
        >
          <DataGrid
            rows={failedMachines.map((item, index) => ({
              id: index + 1,
              ...item,
            }))}
            columns={columnsDataTableFailedMachines}
            disableColumnMenu
            checkboxSelection={false}
            hideFooterSelectedRowCount
            disableVirtualization
            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            slotProps={{
              pagination: dataGridPaginationSlotProps,
            }}
            sx={{
              "& .MuiDataGrid-row": {
                backgroundColor: "#ffe5e5",
              },
            }}
          />
        </div>

        <div style={{ textAlign: "end", marginBottom: "10px" }}>
          {t("page")} {paginationModel.page + 1}
        </div>

        <div
          className="btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              justifyContent: "flex-start",
              gap: "15px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#F44336",
                  borderRadius: "50%",
                }}
              ></span>
              <span
                style={{
                  fontSize: "14px",
                  color: "#F44336",
                  fontWeight: "bold",
                }}
              >
                {t("Failed")}
              </span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              className="btn btn-primary btn-save ml-10"
              onClick={() => {
                setOpenFailedMachinesTransfer(false);
              }}
            >
              {t("ok")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        title={t("machineTransferTitle")}
        open={openFormMachineTransfer}
        setOpen={setOpenFormMachineTransfer}
      >
        <div className="form-confirm-delete">
          <TextField
            select
            label={t("formAction.Groups")}
            value={selectedGroupMachineTransfer}
            onChange={handleGroupChangeTransferMachine}
            variant="outlined"
            fullWidth
            sx={{
              mt: 1,
              borderRadius: "8px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#e0e0e0",
                },
                "&:hover fieldset": {
                  borderColor: "primary.main",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              },
            }}
            style={{
              flex: 1,
              minWidth: "250px",
            }}
          >
            {groupOptions.map((option, index) => (
              <MenuItem key={option.value || index} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => {
                setOpenFormMachineTransfer(false);
                setSelectedRowKeys([]);
                setSelectedGroupMachineTransfer("");
              }}
              className="btn btn-no-border"
              style={{ marginRight: "10px" }}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className="btn btn-primary"
              disabled={selectedGroupMachineTransfer === ""}
              onClick={() => {
                setOpenFormMachineTransferConfirm(true);
              }}
            >
              {t("formAction.transfer")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        title={t("machineTransferTitle")}
        open={openFormMachineTransferConfirm}
        setOpen={setOpenFormMachineTransferConfirm}
      >
        <div className="form-confirm-delete">
          <p className="txt-gray-1 fs-16">{t("machineTransferContent")}</p>
          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => {
                setOpenFormMachineTransferConfirm(false);
              }}
              className="btn btn-no-border"
              style={{ marginRight: "10px" }}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className="btn btn-primary"
              onClick={() => {
                if (id) {
                  handleBulkMachinesTransfer(id, selectedRowKeys, () =>
                    getGroupDetailCondition(id),
                  );
                } else {
                  console.warn("Missing id or recordId");
                }
              }}
            >
              {t("ok")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        title={t("machineDelete.titleBulk")}
        open={openFormDeleteBulk}
        setOpen={setOpenFormDeleteBulk}
      >
        <div className="form-confirm-delete">
          <p className="txt-gray-1 fs-16">{t("machineDelete.contentBulk")}</p>
          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => {
                setOpenFormDeleteBulk(false);
                setSelectedRowKeys([]);
              }}
              className="btn btn-no-border"
              style={{ marginRight: "10px" }}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className="btn btn-primary bg-red"
              onClick={() => {
                if (id) {
                  handleBulkMachinesDelete(id, selectedRowKeys, () =>
                    getGroupDetailCondition(id),
                  );
                } else {
                  console.warn("Missing id or recordId");
                }
              }}
            >
              {t("formAction.delete")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        title={t("machineDelete.title")}
        open={openFormDelete}
        setOpen={setOpenFormDelete}
      >
        <div className="form-confirm-delete">
          <p className="txt-gray-1 fs-16">{t("desDeleteCard")}</p>
          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => setOpenFormDelete(false)}
              className="btn btn-no-border"
              style={{ marginRight: "12px" }}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className="btn btn-primary"
              onClick={() => {
                if (id && recordId) {
                  DeleteMachine(id, recordId, () =>
                    getGroupDetailCondition(id),
                  );
                } else {
                  console.warn("Missing id or recordId");
                }
              }}
            >
              {t("formAction.delete")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openMachineDetailsStatus}
        setOpen={setOpenMachineDetailsStatus}
        title={t("machineInfo.status")}
      >
        <div className="form-edit-name">
          <div className="icon-group justify-content-center">
            <div
              className={`icon success ${
                activeStatus === "NORMAL" ? "active" : ""
              }`}
              onClick={() => {
                setActiveStatus(MACHINE_CONDITION.NORMAL);
              }}
            >
              <IconCheck />
            </div>
            <div
              className={`icon warning ${
                activeStatus === "WARNING" ? "active" : ""
              }`}
              onClick={() => {
                setActiveStatus(MACHINE_CONDITION.WARNING);
              }}
            >
              <IconWarning />
            </div>
            <div
              className={`icon error ${
                activeStatus === "ERROR" ? "active" : ""
              }`}
              onClick={() => {
                setActiveStatus(MACHINE_CONDITION.ERROR);
              }}
            >
              <IconError />
            </div>
          </div>

          <div className="flex justify-content-end btn-group-footer mt-8">
            <Button
              onClick={() => {
                setOpenMachineDetailsStatus(false);
                setActiveStatus("");
              }}
              className="btn btn-no-border"
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className="btn btn-primary btn-save ml-10"
              onClick={() => {
                if (id && recordId) {
                  updateMachineStatus(
                    id,
                    recordId,
                    { machineCondition: activeStatus },
                    refreshMachineList,
                    () => getGroupDetailCondition(id),
                  );
                } else {
                  console.error("Group ID or Machine ID is undefined");
                }
              }}
              disabled={!activeStatus}
            >
              {t("formAction.update")}
            </Button>
          </div>
        </div>

        <style>{`
    .icon-group {
    margin-top: -20px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px; 
      margin-bottom: 20px;
    }
    .icon-group .icon {
      font-size: 50px; 
      cursor: pointer;
      opacity: 0.5; 
      transition: transform 0.2s, opacity 0.2s; 
      transform: scale(2.0);
    }
    .icon-group .icon.active {
      opacity: 1; 
      transform: scale(2.2); 
    }
    .icon-group .icon.success.active {
      color: green;
    }
    .icon-group .icon.warning.active {
      color: orange;
    }
    .icon-group .icon.error.active {
      color: red;
    }
    .icon-group .icon.warning {
  background: none; 
  border: none; 
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0; 
}
  `}</style>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openMachineDetails}
        setOpen={setOpenMachineDetails}
        title={t("machineInfo.title")}
        className="dialog-inspection-form"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          className="flex p-4 gap-6"
          style={{
            backgroundColor: "#f5f6f9",
            padding: "16px",
            gap: "20px",
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: isSmallScreen ? "center" : "flex-start",
            flexWrap: isSmallScreen ? "nowrap" : "wrap",
          }}
        >
          <div style={{ flex: isSmallScreen ? "1" : "0 0 160px" }}>
            <FormControl fullWidth>
              <div
                className="image-box-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "0px",
                }}
              >
                <div
                  className="image-box"
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    height: "150px",
                    border: "1px dashed #ccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "4px",
                    backgroundColor: "transparent",
                    position: "relative",
                    marginTop: isSmallScreen ? "0px" : "60px",
                  }}
                >
                  {selectedImage ? (
                    <>
                      <img
                        src={selectedImage}
                        alt="Preview"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                        onClick={(event) => setMenuAnchor(event.currentTarget)}
                      />
                      <Menu
                        anchorEl={menuAnchor}
                        open={Boolean(menuAnchor)}
                        onClose={() => setMenuAnchor(null)}
                      >
                        <MenuItem
                          onClick={() => {
                            setPreviewOpen(true);
                            setMenuAnchor(null);
                          }}
                        >
                          <Visibility
                            style={{ marginRight: "7px", color: "#4a4a4a" }}
                          />
                          {t("preview")}
                        </MenuItem>
                        <Divider style={{ margin: "4px 0" }} />
                        <MenuItem
                          onClick={() => {
                            setPictureFiles([]);
                            setSelectedImage(null);
                            setIsImageRemoved(true);
                            setMenuAnchor(null);
                          }}
                        >
                          <IconDeleteRow />

                          <span style={{ marginLeft: "7px" }}>
                            {t("machineInfo.removeimage")}
                          </span>
                        </MenuItem>
                      </Menu>
                    </>
                  ) : fileError ? (
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        textAlign: "center",
                        position: "absolute",
                      }}
                    >
                      {t("machineInfo.errormessage")}
                    </span>
                  ) : (
                    <span style={{ color: "#ccc" }}>
                      {t("machineInfo.noimage")}
                    </span>
                  )}
                </div>
              </div>

              <input
                id="image-upload"
                type="file"
                accept=".png, .jpg, .jpeg, .gif, .heic"
                onChange={async (event) => {
                  const file = event.target.files?.[0];
                  if (file) {
                    const validImageTypes = [
                      "image/png",
                      "image/jpeg",
                      "image/jpg",
                      "image/gif",
                      "image/heic",
                    ];

                    const fileType = file.type;
                    const fileExtension = file.name
                      .split(".")
                      .pop()
                      ?.toLowerCase();
                    const isHeic =
                      fileType === "image/heic" ||
                      (!fileType && fileExtension === "heic");

                    if (
                      validImageTypes.includes(fileType) ||
                      (!fileType && fileExtension === "heic")
                    ) {
                      if (isHeic) {
                        try {
                          const convertedBlob = await heic2any({
                            blob: file,
                            toType: "image/jpeg",
                          });

                          const convertedFile = new File(
                            [convertedBlob as Blob],
                            `${file.name.replace(/\.heic$/i, ".jpeg")}`,
                            { type: "image/jpeg" },
                          );

                          setPictureFiles([convertedFile]);
                          setSelectedImage(URL.createObjectURL(convertedFile));
                        } catch (error) {
                          setPictureFiles([]);
                          setSelectedImage(null);
                          setFileError(t("machineInfo.errormessage"));
                        }
                      } else {
                        setPictureFiles([file]);
                        setSelectedImage(URL.createObjectURL(file));
                      }

                      setIsImageRemoved(false);
                      setFileError(null);
                    } else {
                      setPictureFiles([]);
                      setSelectedImage(null);
                      setFileError(t("machineInfo.errormessage"));
                    }
                  }
                  event.target.value = "";
                }}
                style={{ display: "none" }}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  component="label"
                  className="btn btn-primary"
                  htmlFor="image-upload"
                  style={{
                    width: "160px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    backgroundColor: "#e2f2ff",
                    color: "#1e2c39",
                    marginBottom: "16px",
                    marginTop: "10px",
                  }}
                >
                  <UploadOutlined className="mr-5" />
                  {t("machineInfo.uploadimage")}
                </Button>
              </div>
              <DataDialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogContent
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    backgroundColor: "transparent",
                  }}
                >
                  <img
                    src={selectedImage || undefined}
                    alt="Full Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      objectFit: "contain",
                    }}
                  />
                </DialogContent>
              </DataDialog>
            </FormControl>
          </div>

          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                  }}
                >
                  <TextField
                    label={`${t("machineInfo.customerMachineNumber")}`}
                    error={!!machineNumberError}
                    className="input-field"
                    value={customerMachineNumber}
                    onChange={(e) => {
                      if (e.target.value.length <= 40) {
                        handleMachineNumberChange(e.target.value);
                      }
                    }}
                    inputProps={{ maxLength: 40 }}
                    InputProps={{
                      endAdornment: machineNumberError && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <IconInputError />
                        </div>
                      ),
                    }}
                  />

                  {machineNumberError ? (
                    <span className="error-text fs-12 ml-15 txt-red">
                      {machineNumberError}
                    </span>
                  ) : (
                    <span className="fs-12 ml-15 txt-gray-1"></span>
                  )}
                </FormControl>

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                    marginTop: "8px",
                  }}
                >
                  <TextField
                    select
                    label={`${t("machineInfo.maker")}*`}
                    value={manufacturer || ""}
                    onChange={(event) => {
                      const selectedId = event.target.value;
                      setmanufacturer(selectedId);
                    }}
                    error={!manufacturer}
                    helperText={!manufacturer ? t("required") : ""}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            width: 250,
                          },
                        },
                      },
                    }}
                  >
                    {manufacturers.map((manufacturer) => (
                      <MenuItem
                        key={manufacturer.machine_manufacturer_id}
                        value={manufacturer.machine_manufacturer_id}
                      >
                        {manufacturer.machine_manufacturer_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                {manufacturer === "0665TE1NFG6ZXQXXYYNY15V0NW" && (
                  <FormControl
                    style={{
                      flex: isSmallScreen
                        ? "1 1 100%"
                        : "1 1 calc(50% - 7.5px)",
                    }}
                  >
                    <TextField
                      label={`${t("machineInfo.makerOther")}`}
                      value={makerOther}
                      error={!!makerOtherError}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          handleMakerOtherChange(e.target.value);
                        }
                      }}
                      inputProps={{ maxLength: 20 }}
                      InputProps={{
                        endAdornment: makerOtherError && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <IconInputError />
                          </div>
                        ),
                      }}
                      className="input-field"
                    />

                    {makerOtherError ? (
                      <span className="error-text fs-12 ml-15 txt-red">
                        {makerOtherError}
                      </span>
                    ) : (
                      <span className="fs-12 ml-15 txt-gray-1"></span>
                    )}
                  </FormControl>
                )}

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                    marginTop: "8px",
                  }}
                >
                  <TextField
                    select
                    label={`${t("machineInfo.machineType")}*`}
                    value={machinetypes || ""}
                    onChange={(event) => {
                      const selectedId = event.target.value;
                      setmachinetypes(selectedId);
                    }}
                    error={!machinetypes}
                    helperText={
                      !machinetypes && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("required")}*
                        </span>
                      )
                    }
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            width: 250,
                          },
                        },
                      },
                    }}
                  >
                    {machinetype.map((type) => (
                      <MenuItem
                        key={type.machine_type_id}
                        value={type.machine_type_id}
                      >
                        {type.type_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                {machinetypes === "0661J7JX6ZDP4HXM46349GPFHW" && (
                  <FormControl
                    style={{
                      flex: isSmallScreen
                        ? "1 1 100%"
                        : "1 1 calc(50% - 7.5px)",
                    }}
                  >
                    <TextField
                      label={`${t("machineInfo.machineTypeOther")}`}
                      value={machineTypeOther}
                      onChange={(e) => {
                        if (e.target.value.length <= 40) {
                          handleMachineTypeOtherChange(e.target.value);
                        }
                      }}
                      inputProps={{ maxLength: 40 }}
                      fullWidth
                      error={!!machineTypeOtherError}
                      InputProps={{
                        endAdornment: machineTypeOtherError && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <IconInputError />
                          </div>
                        ),
                      }}
                      className="input-field"
                    />

                    {machineTypeOtherError ? (
                      <span className="error-text fs-12 ml-15 txt-red">
                        {machineTypeOtherError}
                      </span>
                    ) : (
                      <span className="fs-12 ml-15 txt-gray-1"></span>
                    )}
                  </FormControl>
                )}

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                  }}
                >
                  <TextField
                    label={`${t("machineInfo.modelType")}*`}
                    error={!!modelTypeError}
                    value={modelType}
                    onChange={(e) => {
                      if (e.target.value.length <= 40) {
                        handleModelTypeChange(e.target.value);
                      }
                    }}
                    inputProps={{ maxLength: 40 }}
                    InputProps={{
                      endAdornment: modelTypeError && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <IconInputError />
                        </div>
                      ),
                    }}
                    className="input-field"
                  />

                  {modelTypeError ? (
                    <span className="error-text fs-12 ml-15 txt-red">
                      {modelTypeError}
                    </span>
                  ) : (
                    <span className="fs-12 ml-15 txt-gray-1"></span>
                  )}
                </FormControl>

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                  }}
                >
                  <TextField
                    label={`${t("machineInfo.serialNo")}*`}
                    error={
                      !serialNo ||
                      serialNoError ||
                      forbiddenCharError ||
                      (manufacturer === "0661ATBN7XH5EB1NXCFDF4ZTMG" &&
                        (machinetypes === "0661J7JX6ZDP4HXM46349GPFHW"
                          ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                              serialNo,
                            )
                          : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                              serialNo,
                            )))
                    }
                    value={serialNo}
                    onChange={(event) => {
                      const value = event.target.value.toUpperCase();

                      if (manufacturer === "0661ATBN7XH5EB1NXCFDF4ZTMG") {
                        if (
                          (machinetypes === "0661J7JX6ZDP4HXM46349GPFHW"
                            ? /^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                                value,
                              )
                            : /^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                                value,
                              )) ||
                          value === ""
                        ) {
                          setSerialNoError(false);
                        } else {
                          setSerialNoError(true);
                        }
                      } else {
                        setSerialNoError(value.length > 20);
                      }

                      setserialNo(value);
                    }}
                    onKeyDown={(event) => {
                      const allowedKeys = /^[A-Z0-9]$/;
                      const navigationKeys = ["ArrowLeft", "ArrowRight"];

                      if (
                        !allowedKeys.test(event.key.toUpperCase()) &&
                        event.key !== "Backspace" &&
                        event.key !== "Delete" &&
                        !navigationKeys.includes(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(event) => {
                      event.preventDefault();
                      const pastedText = event.clipboardData
                        .getData("text")
                        .toUpperCase();
                      const sanitizedText = pastedText.replace(
                        /[^A-Z0-9]/g,
                        "",
                      );
                      setserialNo(sanitizedText);
                    }}
                    helperText={
                      !serialNo ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("required")}*
                        </span>
                      ) : forbiddenCharError ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("machineInfo.serialNoTooLong")}
                        </span>
                      ) : manufacturer === "0661ATBN7XH5EB1NXCFDF4ZTMG" &&
                        (machinetypes === "0661J7JX6ZDP4HXM46349GPFHW"
                          ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                              serialNo,
                            )
                          : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                              serialNo,
                            )) ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("machineInfo.serialNoTooLong")}
                        </span>
                      ) : serialNo.length > 20 ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("machineInfo.serialNoTooLong")}
                        </span>
                      ) : null
                    }
                    InputProps={{
                      endAdornment: (!serialNo ||
                        serialNoError ||
                        forbiddenCharError ||
                        (manufacturer === "0661ATBN7XH5EB1NXCFDF4ZTMG" &&
                          (machinetypes === "0661J7JX6ZDP4HXM46349GPFHW"
                            ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                                serialNo,
                              )
                            : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                                serialNo,
                              )))) && <IconInputError />,
                    }}
                    className="input-field"
                  />
                </FormControl>
              </div>
            </div>

            <div
              className="wrapper-text-field mt-8"
              style={{ marginBottom: "0px" }}
            >
              <MediaUploadMachine
                key={refreshKey}
                setFileCount={setFileCount}
                medias={mediaFiles}
                setMedias={(files: File[]) => {
                  const existingFiles = mediaFiles.map(
                    (file: any) =>
                      file.filePath || file.mediaUrl || file.thumbnailUrl,
                  );
                  const newFiles = files.map(
                    (file: any) => file.filePath || file.mediaUrl,
                  );
                  const removedFiles = existingFiles.filter(
                    (mediaUrl: string) => !newFiles.includes(mediaUrl),
                  );
                  if (removedFiles.length > 0) {
                    setRemovedMediaUrls((prev: any) => [
                      ...prev,
                      ...removedFiles,
                    ]);
                  }
                  setMediaFiles(files);
                  setFileCount(files.length);
                }}
                typeFile={TYPE_FILE_UPLOAD.image}
                uploadDescription={uploadDescription}
              />
            </div>
          </div>
        </div>

        <div
          className="flex justify-content-end btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <Button
            onClick={() => {
              setSelectedImage(null);
              setSelectedImageSerial(null);
              setFileError(null);
              setFileErrorSerial(null);

              setmanufacturer(null);
              setmachinetypes(null);
              setmakerOther(null);
              setmachineTypeOther(null);
              setmodelType(null);
              setserialNo(null);
              setCustomerMachineNumber("");

              setMachineNumberError("");
              setMakerOtherError("");
              setMachineTypeOtherError("");
              setModelTypeError("");
              setSerialNoError(false);
              setForbiddenCharError(false);
              setOpenMachineDetails(false);
              setMediaFiles([]);
              setPictureFiles([]);

              setSerialNumberFiles([]);
              setIsImageRemoved(false);
              setIsImageRemovedSerial(false);
            }}
            className="btn btn-no-border"
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className="btn btn-primary btn-save ml-10"
            onClick={() => {
              if (id && recordId) {
                updateMachine(
                  id,
                  recordId,
                  {
                    machineName:
                      customerMachineNumber?.trim() ||
                      `${modelType}-${serialNo}`,
                    machineManufacturerId: manufacturer || "",
                    machineTypeId: machinetypes || "",
                    modelAndType: modelType || "",
                    serialNumber: serialNo || "",
                    customMachineManufacturerName: makerOther || null,
                    customTypeName: machineTypeOther || null,
                  },
                  pictureFiles,

                  mediaFiles,
                  refreshMachineList,
                );
              } else {
                console.error("Group ID or Machine Id is undefined");
              }
            }}
            disabled={
              serialNoError ||
              !!machineTypeOtherError ||
              !!modelTypeError ||
              !!makerOtherError ||
              !!machineNumberError ||
              !manufacturer ||
              !machinetype ||
              !modelType ||
              !serialNo ||
              (manufacturer === "0661ATBN7XH5EB1NXCFDF4ZTMG" &&
                (machinetypes === "0661J7JX6ZDP4HXM46349GPFHW"
                  ? serialNo.length > 10
                  : serialNo.length > 8))
            }
          >
            {t("formAction.update")}
          </Button>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openMachineDetailsNew}
        setOpen={setOpenMachineDetailsNew}
        title={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "column",
            }}
          >
            {t("machineInfo.title")}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                justifyContent: "flex-start",
                gap: "15px",
              }}
            >
              {errorRows.length > 0 && (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: "#F44336",
                      borderRadius: "50%",
                    }}
                  ></span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#F44336",
                      fontWeight: "bold",
                    }}
                  >
                    {t("failedToAddUpdateRows", { count: errorRows.length })}
                  </span>
                </div>
              )}
            </div>
          </div>
        }
        className="dialog-inspection-form"
      >
        <div
          style={{
            width: "100%",
            height: 400,
            overflow: "auto",
            marginBottom: "20px",
          }}
        >
          <DataGrid
            rows={rowsDataTable}
            columns={
              errorRows.length > 0
                ? [...errorColumns, ...columnsDataTable.slice(1)]
                : columnsDataTable
            }
            slotProps={{
              pagination: dataGridPaginationSlotProps,
            }}
            disableColumnMenu
            checkboxSelection={false}
            hideFooterSelectedRowCount
            disableVirtualization
            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            getRowClassName={(params) => {
              switch (params.row.status) {
                case "posted":
                  return "row-posted";
                case "updated":
                  return "row-updated";
                case "error":
                  return "row-error";
                default:
                  return "";
              }
            }}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                fontWeight: "bold",
                backgroundColor: "#f5f5f5",
                position: "sticky",
                top: 0,
                zIndex: 1,
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .row-posted": {
                backgroundColor: "#c8e6c9 !important",
              },
              "& .row-updated": {
                backgroundColor: "#fff9c4 !important",
              },
              "& .row-error": {
                backgroundColor: "#ffcdd2 !important",
              },
            }}
          />
        </div>

        <div style={{ textAlign: "end", marginBottom: "10px" }}>
          {t("page")} {paginationModel.page + 1}
        </div>

        <div
          className="btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => {
                setOpenMachineDetailsNew(false);
                setRowsDataTable([]);
                setHasApiFailedRows(false);
              }}
              className="btn btn-no-border"
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className="btn btn-primary btn-save"
              onClick={handleUpdateClick}
              disabled={hasApiFailedRows}
            >
              {t("formAction.update")}
            </Button>
          </div>
        </div>
        {showLargeCountWarning && (
          <Dialog
            open={showLargeCountWarning}
            onClose={(event, reason) => {
              if (reason !== "backdropClick") {
                setShowLargeCountWarning(false);
              }
            }}
          >
            <DialogTitle
              sx={{ py: "16px", paddingInlineStart: "24px !important" }}
            >
              {t("formAction.update")}
            </DialogTitle>
            <DialogContent sx={{ padding: "8px 24px" }}>
              <DialogContentText>{t("largeCountWarning")}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                  padding: "8px 16px",
                  width: "100%",
                }}
              >
                <Button
                  onClick={() => setShowLargeCountWarning(false)}
                  className="btn btn-no-border"
                >
                  {t("dialogReport.cancel")}
                </Button>
                <Button
                  className="btn btn-primary btn-save"
                  onClick={() => {
                    setShowLargeCountWarning(false);
                    handleUpdatePostMachine();
                  }}
                >
                  {t("formAction.update")}
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        )}
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openAddMachineDetailsNew}
        setOpen={setOpenAddMachineDetailsNew}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "60%",
                fontWeight: "bold",
                fontSize: "25px",
              }}
            >
              {t("formAction.Addmachine")}
            </span>
          </div>
        }
        className="dialog-inspection-form"
      >
        {cards.map(renderMachineCard)}

        <div className="flex-centered mt-24">
          <Tooltip title={cards.length > 49 ? t("limit") : ""} arrow>
            <span style={{ display: "inline-block" }}>
              <Button
                onClick={addNewCard}
                disabled={cards.length > 49}
                sx={{
                  backgroundColor: cards.length > 49 ? "#d3d3d3" : "#eaf4ff",
                  border: "none",
                  borderRadius: "20px",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  color: "black",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: cards.length > 49 ? "not-allowed" : "pointer",
                  opacity: cards.length > 49 ? 0.6 : 49,
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s ease",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: cards.length > 49 ? "#d3d3d3" : "#cce5ff",
                  },
                }}
              >
                <Add style={{ fontSize: "16px" }} />
                {t("machineInfo.addnew")}
              </Button>
            </span>
          </Tooltip>
        </div>

        <div
          className="flex justify-content-end btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <Button
            style={{ width: "auto" }}
            onClick={() => {
              setOpenAddAvailableMachineDetailsNewConfirmCancel(true);
            }}
            className="btn btn-no-border"
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className="btn btn-primary"
            style={{ width: "auto" }}
            onClick={submitMachines}
            disabled={!isFormValid || isAddDisabled}
          >
            {t("formAction.add")}
          </Button>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openAddAvailableMachineDetailsNew}
        setOpen={setOpenAddAvailableMachineDetailsNew}
        title={t("machineInfo.AvailableMachine")}
        className="dialog-inspection-form"
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            maxWidth: "100%",
            margin: "16px auto",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <TextField
            select
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            label={t("formAction.Groups")}
            variant="outlined"
            fullWidth
            style={{
              flex: 1,
              minWidth: "250px",
            }}
          >
            <MenuItem value="all">{t("all")}</MenuItem>
            {groupsList.map((group, index) => (
              <MenuItem key={index} value={group}>
                {group}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            value={selectedMachineType}
            onChange={(e) => setSelectedMachineType(e.target.value)}
            label={t("machineInfo.machineType")}
            variant="outlined"
            fullWidth
            style={{
              flex: 1,
              minWidth: "250px",
            }}
          >
            <MenuItem value="all">{t("all")}</MenuItem>
            {machineTypesList.map((type, index) => (
              <MenuItem key={index} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>

          <div style={{ position: "relative", flex: 1, minWidth: "250px" }}>
            <Search
              style={{
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "black",
              }}
              size={18}
            />

            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder={t("Customermachinenumber")}
              style={{
                width: "100%",
                height: "55px",
                padding: "10px 40px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                backgroundColor: "#f5f5f5",
                fontSize: "16px",
                outline: "none",
                boxShadow: "none",
                color: "black",
              }}
            />

            {searchText && (
              <X
                tabIndex={0}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "black",
                  cursor: "pointer",
                }}
                size={18}
                onClick={() => setSearchText("")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setSearchText("");
                }}
              />
            )}
          </div>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            {/* <CircularProgress size={40} sx={{ color: "#140a9a" }} /> */}
          </div>
        ) : (
          <div
            style={{ maxHeight: "300px", overflowY: "auto", padding: "10px 0" }}
          >
            {filteredMachines.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                  marginLeft: "10px",
                  marginRight: "5px",
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    color: "#333",
                  }}
                >
                  {t("machineInfo.AvailableMachine")}
                </p>
                {selectedGroup === "all" &&
                  selectedMachineType === "all" &&
                  searchText === "" && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0px",
                      }}
                    >
                      <Checkbox
                        id="selectAllMachines"
                        checked={selectAll}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setSelectAll(checked);

                          if (checked) {
                            const allSelected: any = {};
                            const allSelectedList: any[] = [];

                            filteredMachines.forEach((machine) => {
                              allSelected[machine.machineId] = true;
                              allSelectedList.push(machine);
                            });

                            setSelectedMachines(allSelected);
                            setSelectedMachineList(allSelectedList);
                          } else {
                            setSelectedMachines({});
                            setSelectedMachineList([]);
                          }
                        }}
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#140a9a",
                          },
                        }}
                      />
                    </div>
                  )}
              </div>
            )}

            {filteredMachines.length > 0 ? (
              filteredMachines.map((machine, index) => (
                <div key={machine.machineId}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px",
                      backgroundColor: "#fff",
                      marginBottom: "0px",
                    }}
                  >
                    <img
                      src={machine.pictureUrl}
                      alt={machine.machineName}
                      style={{
                        width: "50px",
                        height: "50px",
                        marginRight: "12px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                      }}
                    />

                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {machine.machineName}
                      </div>
                      <div style={{ fontSize: "16px", color: "#666" }}>
                        {machine.modelAndType} •{" "}
                        {machine.machineManufacturerName}
                      </div>
                    </div>

                    {selectedMachines[machine.machineId] ? (
                      <Check
                        size={24}
                        style={{ color: "green", cursor: "pointer" }}
                        onClick={() => toggleSelection(machine)}
                      />
                    ) : (
                      <Plus
                        size={24}
                        style={{ color: "#333", cursor: "pointer" }}
                        onClick={() => toggleSelection(machine)}
                      />
                    )}
                  </div>
                  <Divider></Divider>
                </div>
              ))
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "#888",
                  fontSize: "18px",
                  padding: "50px",
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/dropbox.png`}
                  alt="No machines"
                  style={{ width: "80px", marginBottom: "0px" }}
                />
                <p>{t("noregmach")}</p>
              </div>
            )}
          </div>
        )}
        <div
          className="flex justify-end btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <Button
            style={{ width: "auto" }}
            onClick={() => {
              setGroupsList([]);
              setMachineTypesList([]);
              setSelectedGroup("all");
              setSelectedMachineType("all");
              setSearchText("");
              setSearchText("");
              setSelectedMachines({});
              setSelectedMachineList([]);
              setMachines([]);
              setOpenAddAvailableMachineDetailsNew(false);
              setSerialNoError(false);
              setForbiddenCharError(false);
              setSelectAll(false);
            }}
            className="btn btn-no-border"
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className="btn btn-primary"
            style={{ width: "auto" }}
            onClick={async () => {
              setCards((prevCards) => {
                const duplicateMachines: string[] = [];

                const newCards = selectedMachineList

                  .filter((machine) => {
                    const isDuplicate = prevCards.some(
                      (card) =>
                        card.serialNumber === machine.serialNumber &&
                        card.modelAndType === machine.modelAndType,
                    );

                    if (isDuplicate) {
                      duplicateMachines.push(machine.machineName);
                      return false;
                    }

                    return true;
                  })
                  .map((machine, index) => {
                    const uniqueCardId = generateCardUniqueId(
                      prevCards.map((card) => String(card.cardId)),
                    );

                    return {
                      cardId: uniqueCardId,
                      index: prevCards.length + index,
                      isOpen: false,
                      machineName: machine.machineName,
                      modelAndType: machine.modelAndType,
                      serialNumber: machine.serialNumber,
                      machineManufacturerId:
                        machine.machineManufacturerId || "",
                      machineTypeId: machine.machineTypeId || "",
                      customMachineManufacturerName:
                        machine.customMachineManufacturerName || "",
                      customTypeName: machine.customTypeName || "",

                      pictureUrlDB: machine.pictureUrlDB || null,
                      pictureUrl: null,
                      serialNumberPlatePictureUrlDB:
                        machine.serialNumberPlatePictureUrlDB || null,
                      serialNumberPlatePictureUrl: [],
                      setPictureFiles: [],
                      isCopied: true,
                      errors: {
                        forbiddenCharError: false,
                        machineNumberError: false,
                        machineTypeOtherError: false,
                        makerOtherError: false,
                        modelTypeError: false,
                        serialNoError: false,
                      },
                    };
                  });

                if (duplicateMachines.length > 0) {
                  store.dispatch(
                    setShowAlert(t("Thesemachinesarealreadyinthecardlist")),
                  );
                }

                if (newCards.length > 0) {
                  store.dispatch(setShowAlert(t("Machinesaddedinthecardlist")));
                  return [...prevCards, ...newCards];
                }

                return prevCards;
              });

              setGroupsList([]);
              setMachineTypesList([]);
              setSelectedGroup("all");
              setSelectedMachineType("all");
              setSearchText("");
              setSelectedMachines({});
              setSelectedMachineList([]);
              setMachines([]);
              setOpenAddAvailableMachineDetailsNew(false);
              setSerialNoError(false);
              setForbiddenCharError(false);
              setSelectAll(false);
            }}
            disabled={
              machines.length === 0 ||
              (selectedMachineList.length === 0 &&
                !machines.some((machine) =>
                  selectedMachineList.some(
                    (selected) => selected.machineId === machine.machineId,
                  ),
                ))
            }
          >
            {t("formAction.add")}
          </Button>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openAddAvailableMachineDetailsNewConfirmCancel}
        setOpen={setOpenAddAvailableMachineDetailsNewConfirmCancel}
        title={t("titleConfirm")}
      >
        <p className="txt-gray-1 fs-16">{t("")}</p>
        <div
          className="wrapper-btn flex-centered justify-content-end mt-24"
          style={{ display: "flex", gap: "12px" }}
        >
          <Button
            className="btn btn-no-border"
            onClick={() => {
              setOpenAddAvailableMachineDetailsNewConfirmCancel(false);
            }}
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className="btn btn-primary"
            style={{ width: "auto" }}
            onClick={() => {
              setOpenAddMachineDetailsNew(false);
              setOpenAddAvailableMachineDetailsNewConfirmCancel(false);
              setCards([]);
            }}
          >
            {t("ok")}
          </Button>
        </div>
      </DataDialog>

      <DataDialog
        disableBackdropClick={true}
        open={openExcelWarn}
        setOpen={setExcelWarn}
        title={
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{t("excelimport")}</span>
            <span
              className="fs-16 txt-gray-3"
              style={{ color: "#6B7280", marginTop: "-4px" }}
            ></span>
          </div>
        }
      >
        <div
          className="warning flex justify-content-start"
          style={{ marginTop: 0, marginBottom: "10px" }}
        >
          <IconWarningFormEdit />
          <span style={{ marginLeft: 12, flex: 1 }} className="txt-black-1">
            {t("warningUpdateItem2")}
          </span>
        </div>

        <div
          className="flex justify-end btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <Button
            style={{ width: "auto", marginTop: "4px" }}
            className="btn btn-no-border"
            onClick={() => {
              setExcelWarn(false);
              handleClose();
            }}
          >
            {t("dialogReport.cancel")}
          </Button>

          <label htmlFor="file-upload">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#10069F",
                color: "#FFFFFF",
                borderRadius: "50px",
                padding: "10px 10px",
                fontSize: "14px",
                fontWeight: "normal",
                fontFamily: "Arial, sans-serif",
                letterSpacing: "0.5px",
                minWidth: "100px",
                textTransform: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                "&:hover": {
                  backgroundColor: "#253fc8",
                },
              }}
              component="span"
            >
              {t("chooseFile")}
            </Button>
            <input
              id="file-upload"
              type="file"
              accept=".xlsx, .xls"
              style={{ display: "none" }}
              onClick={handleInputClick}
              onChange={(e) => {
                handleFileExcelRead(e);
                e.target.value = "";
                handleClose();
              }}
            />
          </label>
        </div>
      </DataDialog>

      <AnnouncementPopupModal
        announcements={announcements}
        announcementsLoading={announcementsLoading}
        openAnnouncements={openAnnouncements}
        setOpenAnnouncements={setOpenAnnouncements}
        isoLocaleCode={userIsoLocaleCode}
        userTimeFormat={userTimeFormat}
      />
    </div>
  );
}
